export const alpha200Data = {
  Alpha_nifty_200: [
    {
      strategy: "d_25_10_26",
      ytds: [
        {
          year: 2011,
          ytd_data: "-20.62%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.5%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "3.6%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-4.1%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-4.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "2.9%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "0.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-4.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "-0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "0.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-3.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "1.3%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "0.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "5.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "34.94%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "10.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "5.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "3.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "4.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-7.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "-0.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "1.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "-0.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-0.2%",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "1.2%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-1.9%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "3.4%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-3.2%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-3.6%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "0.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "1.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "1.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "2.9%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "-2.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "3.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "0.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "-0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "0.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "3.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "1.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-1.4%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "3.5%",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "4.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "4.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "-1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "8.73%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-3.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "-2.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-2.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "-0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-1.3%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "-1.7%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-4.1%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "0.5%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "-0.8%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-6.8%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "1.6%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-2.6%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "1.8%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "5.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "2.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-0.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-2.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "1.0%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "3.3%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "4.3%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-1.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "4.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "1.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "2.1%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "3.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "1.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "2.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "0.8%",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "10.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "2.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "70.12%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "-0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "1.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "-0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "-0.0%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.1%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.6%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "2.0%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "2.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "2.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "2.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "4.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "-0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-1.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "2.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "5.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "6.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "14.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "9.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-1.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "2.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "5.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-10.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "6.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "-1.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "0.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "2.2%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "4.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-0.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-3.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-3.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.6%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "3.5%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "-0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "3.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "0.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "2.7%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "3.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-3.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-2.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "0.5%",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "10.51%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "-0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "2.8%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "0.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "2.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "7.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "1.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "2.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-1.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.3%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-1.8%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "4.2%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-14.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "0.4%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-6.8%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-2.1%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-0.9%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "3.3%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "2.2%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "0.9%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-2.7%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "0.4%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "0.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-2.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "1.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-5.2%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "2.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-0.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-3.6%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-1.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "4.4%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-10.31%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-11.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-7.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "5.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.3%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "-1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "3.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "0.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "3.7%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "3.9%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "-0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "6.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "1.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-2.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-4.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-3.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "4.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.4%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "-0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "1.7%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-6.2%",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "0.8%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-2.9%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "0.4%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-2.2%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "4.0%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-4.7%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.0%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "1.2%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "36.78%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "13.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "4.3%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "2.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "3.4%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "-0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-2.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "1.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-2.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "2.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "-0.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "1.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "3.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-3.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "0.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-3.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-2.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "2.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "1.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "0.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "0.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "6.0%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-2.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "1.8%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "2.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "5.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "-0.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "3.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-16.66%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-13.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "-1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "2.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-13.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "3.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-0.6%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "1.1%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-2.1%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-3.7%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "0.1%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-1.7%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "1.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.5%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "1.6%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "2.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "4.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-0.3%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "3.8%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-1.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "0.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "0.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "1.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-2.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-1.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-1.2%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-7.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "5.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "5.3%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-1.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-2.3%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-0.6%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "9.20%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-2.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-1.1%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-2.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "7.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "1.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "2.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "2.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "-0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "-2.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-2.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "3.8%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "4.4%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "-0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "2.2%",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "-1.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-0.8%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "0.6%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-1.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "1.3%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-2.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "3.3%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "1.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "3.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-3.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "2.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "41.83%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-4.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "5.3%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.5%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-7.2%",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-13.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "-6.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "18.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "13.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "-0.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "1.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "-0.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "3.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "2.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "-0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "-0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "2.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-5.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "5.1%",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "-0.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "0.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "-1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "26.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "4.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "4.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "5.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "6.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "3.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "2.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "1.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "74.58%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "7.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-0.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-2.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "23.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "11.1%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "4.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "4.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "11.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "7.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "0.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-1.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.0%",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "4.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.9%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "7.3%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "14.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "9.9%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "4.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-10.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-9.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "-0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "-0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "1.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "0.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-3.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "2.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "3.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "5.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-5.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-3.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "2.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-1.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-6.5%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "2.4%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.1%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-1.6%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "1.2%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "3.0%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "21.17%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.2%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-5.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-4.5%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "2.5%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-9.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-1.0%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-3.6%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "-1.6%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "10.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.2%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "0.4%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "3.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "2.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "1.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-11.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-3.9%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-10.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "5.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "2.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "11.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "4.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "5.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "2.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "2.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "-0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-4.6%",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "0.0%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-3.8%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "2.6%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.5%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "9.4%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "52.44%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "0.8%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-0.1%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-1.3%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-6.3%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "1.5%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "-0.3%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-1.8%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-4.3%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "3.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "-0.8%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "3.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "-0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "0.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "4.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "1.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "3.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-1.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "3.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "6.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "-1.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.6%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.0%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "19.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "5.8%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.4%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "-0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "8.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "3.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "45.63%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-0.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "1.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-2.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "5.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "3.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.4%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "4.7%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-5.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "11.5%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "5.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "8.7%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "0.6%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "2.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "0.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-7.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.3%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "2.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "2.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "1.2%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-3.0%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "2.8%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "0.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "-0.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-5.4%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "5.4%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.8%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-6.7%",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-2.5%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "2.2%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-2.3%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "4.1%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "0.9%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "2.8%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "4.9%",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "2.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-2.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "-0.0%",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-14.16%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-16.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-7.8%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "-2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-4.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-6.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "6.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-3.0%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "-0.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "-0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-2.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "1.1%",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "1.9%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "1.5%",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "d_25_10_52",
      ytds: [
        {
          year: 2011,
          ytd_data: "-19.25%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-1.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "4.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "1.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "1.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "0.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "0.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-4.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "4.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-7.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-4.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-4.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "0.0%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "36.12%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "11.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "2.8%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "5.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "1.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "0.5%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "-0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "1.9%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "3.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "3.5%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "20.38%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-2.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-1.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "3.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "-0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "1.9%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "2.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "38.02%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "0.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "6.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-9.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "9.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "5.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "-0.5%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "11.20%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "6.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "5.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-11.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-6.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "3.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-3.6%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "2.1%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.0%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-5.6%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "4.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "0.7%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-2.6%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "1.1%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-7.40%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-8.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "6.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "-1.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "0.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "2.7%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "-0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "2.7%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "6.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-5.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "-3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-1.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-3.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-6.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "3.7%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "50.14%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "17.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "5.1%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "0.9%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "4.4%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "6.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-13.78%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-14.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "-0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "-1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "5.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "1.6%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "2.5%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.9%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-7.6%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "4.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "2.3%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-2.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "3.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-1.9%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "0.2%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "1.36%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "0.6%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-3.2%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "0.0%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "2.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "2.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "2.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-1.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "4.4%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "2.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "17.68%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-3.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "6.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-7.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-18.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-9.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "-9.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "14.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "13.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-0.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "0.2%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "-0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "-0.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "1.5%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-0.9%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "-3.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "2.6%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "5.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "17.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "47.60%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-6.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "10.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "9.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "11.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "7.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "11.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "5.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-4.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "1.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.5%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "7.47%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-4.8%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-0.9%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "3.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "1.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-14.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-11.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-4.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "1.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-7.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "12.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "3.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.9%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "14.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-3.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-4.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "4.0%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-8.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "7.7%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "31.79%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-18.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "-2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-7.9%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "-7.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "1.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "0.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "4.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "14.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "4.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "5.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "5.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "20.89%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "6.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "8.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-4.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-8.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "2.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-5.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "5.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "-0.7%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-0.93%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-11.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-9.3%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-5.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "0.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-5.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "8.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "-0.2%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-3.2%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "10.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "3.3%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "d_50_10_26",
      ytds: [
        {
          year: 2011,
          ytd_data: "-19.90%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-1.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "2.9%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "0.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "1.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "2.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "-0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "0.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-3.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "1.3%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "0.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "5.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "30.32%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "10.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "5.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-8.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-0.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-3.6%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "0.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "3.4%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "11.53%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-4.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-6.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "1.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "2.6%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "4.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "4.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "4.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "2.1%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "3.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "0.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "10.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "68.15%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "-0.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "13.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "4.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-9.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "-0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "2.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "0.5%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "10.47%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "4.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-5.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "0.7%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "5.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "0.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-5.2%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "2.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-3.6%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-1.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "4.4%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-11.19%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-11.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-7.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "5.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.3%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "-1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "3.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "3.7%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "3.9%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "6.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-5.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "0.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "1.2%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "46.47%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "12.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "4.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "2.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "3.4%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "-1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "6.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-11.73%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-10.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-10.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "0.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "1.9%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "3.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-2.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-10.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-8.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "5.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-1.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "5.3%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-0.7%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-1.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-0.4%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "3.71%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-1.1%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-2.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "1.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "4.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "-0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "2.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-10.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "0.2%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "3.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "43.94%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-6.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "-6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "18.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "13.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "-0.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "1.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "-0.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "0.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "0.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "4.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "25.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "7.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "67.16%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "22.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "11.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "7.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "14.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "9.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "7.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-11.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-9.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-6.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "2.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "3.0%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "21.09%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-4.5%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "2.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-9.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-4.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "-1.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "10.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "0.6%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-11.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-3.9%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-11.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "5.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "2.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "11.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "4.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "5.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-4.6%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "0.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-3.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "9.4%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "46.44%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-6.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "1.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "-0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-4.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "3.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "-0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "-1.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "3.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "6.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "15.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "3.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "7.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "48.42%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "6.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "11.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "8.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "5.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-6.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "0.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "4.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "-0.0%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-15.30%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-16.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-7.8%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "-2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-4.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-6.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "6.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-3.0%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "-0.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "-0.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-2.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "d_50_10_52",
      ytds: [
        {
          year: 2011,
          ytd_data: "-18.82%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-1.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "4.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "1.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "1.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "1.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "0.5%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "0.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-4.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "4.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-4.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "0.0%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "36.18%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "11.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "2.8%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "5.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "1.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-5.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "-0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-0.2%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "-0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "1.9%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "3.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "4.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "18.95%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-0.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "1.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-3.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "0.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "1.3%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "3.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "-0.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-3.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "7.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "2.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "2.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "35.38%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "0.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "14.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "7.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-10.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "9.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "5.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "-0.1%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "13.31%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "6.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "5.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-5.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "2.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "3.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-3.6%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "2.1%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.0%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-5.6%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "3.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-2.6%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "1.6%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-8.20%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-8.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "6.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "-1.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "0.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "2.7%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "-0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "1.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "2.7%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "6.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-5.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "-3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-1.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "3.0%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "48.05%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "15.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "3.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "4.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "-0.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "5.0%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "7.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "3.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-19.46%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-14.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "-0.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "-1.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "1.6%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "2.5%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.9%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-7.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "3.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-2.4%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "1.9%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-3.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-2.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "3.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "0.9%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "2.18%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "0.3%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-3.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "1.4%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "2.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "1.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "-0.0%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "4.0%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "2.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "24.31%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-3.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "6.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-7.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-18.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-9.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "-9.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "14.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "13.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-0.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "0.2%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "-0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "-0.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "1.5%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-0.9%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "-2.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "2.4%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "3.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "5.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "17.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "57.62%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-6.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "9.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "6.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "11.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "5.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "1.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.6%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "6.87%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-4.8%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-0.9%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "3.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "1.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-15.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-11.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-4.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "1.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-7.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "12.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "3.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.9%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "14.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-3.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-4.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "4.0%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-8.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "7.7%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "32.83%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-18.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "-2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-7.9%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "-7.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "1.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "0.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "4.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "5.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "22.17%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "6.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "8.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-4.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-7.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-4.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "3.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "3.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "-0.1%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-2.66%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-10.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-8.8%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-5.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-6.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-5.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "8.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "-0.2%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-3.5%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "10.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "5.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "0.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "3.3%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "l_25_10_26",
      ytds: [
        {
          year: 2011,
          ytd_data: "-48.46%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-10.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-8.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "6.2%",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "3.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "4.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "3.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "1.6%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "-1.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "-5.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-19.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-4.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-10.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "5.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "9.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-2.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-4.2%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "5.7%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "-0.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-16.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-5.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-13.8%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "7.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-9.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-6.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-6.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "0.5%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "75.04%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "54.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "9.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "15.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "7.7%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "10.0%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "3.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-0.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-1.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "3.4%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-3.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-3.7%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-10.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-5.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-3.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "0.7%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "0.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-5.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "13.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "6.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "3.4%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "-15.92%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "-0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-4.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-9.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-6.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "-3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "13.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "4.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-10.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "-4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-28.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "-1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-7.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-16.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "-4.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "22.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "11.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "0.3%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "2.1%",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "3.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "3.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "10.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "73.04%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "-0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "-0.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "14.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "5.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-10.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "0.8%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "17.21%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "6.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "3.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "4.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-14.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-6.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "0.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "-5.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-4.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "-0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "20.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "13.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "6.6%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-6.9%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "1.9%",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-9.26%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-5.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-6.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-10.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "8.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.4%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "2.2%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "3.4%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "3.9%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-0.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "-1.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "2.5%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-6.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "0.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "0.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "4.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-4.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "1.2%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "29.08%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "9.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "2.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "1.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "0.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "6.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-4.95%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-13.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-3.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-1.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "2.8%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-6.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "8.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "6.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-2.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-7.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-6.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "14.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-0.5%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "-2.9%",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-1.2%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-4.4%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "7.0%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "1.5%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-0.4%",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "0.27%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "-1.3%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-1.1%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "10.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-0.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "3.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "6.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "3.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "4.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "1.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-10.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-0.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "-0.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-12.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "7.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "-8.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-10.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "17.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "-3.3%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "13.9%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-5.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "12.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "112.16%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "5.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-7.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-22.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-11.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "-6.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "29.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "9.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "10.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-8.4%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-3.1%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "6.3%",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "49.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "19.5%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "8.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "9.2%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "8.1%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-2.7%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "1.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "-5.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "1.5%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "-3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "19.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "6.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "5.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "24.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "75.55%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "23.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "11.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "11.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "7.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "14.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "9.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-10.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-9.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-6.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-6.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "2.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "3.0%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "13.64%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-4.5%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "2.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-9.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "-2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "5.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "-3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "4.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "-1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-5.2%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-4.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-5.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "1.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "10.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "-1.1%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "7.5%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "2.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "10.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-4.6%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "2.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-3.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "-0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "9.4%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "69.41%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-6.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "1.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "-0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "4.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "4.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "-3.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "1.7%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "-0.6%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "1.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "19.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "5.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "7.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "46.43%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "4.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "11.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "8.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-5.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "5.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-6.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-2.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-2.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "4.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "0.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "4.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "-0.0%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "17.89%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-6.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "6.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-0.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-14.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "-2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-8.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-6.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "10.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "6.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "6.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "-0.1%",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-2.2%",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "14.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "5.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "5.2%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "2.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "11.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "9.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "l_25_10_52",
      ytds: [
        {
          year: 2011,
          ytd_data: "-38.89%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-1.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "4.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "1.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "1.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "0.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-21.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-8.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-12.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "5.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "10.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-3.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "6.1%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "-1.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-16.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-5.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-15.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "5.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-13.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-6.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-9.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "31.73%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "45.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "8.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "13.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "11.9%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "3.5%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-9.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "-5.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "0.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "4.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-6.0%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-5.3%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-14.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-4.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "17.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "6.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "3.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "6.9%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "3.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "3.6%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "18.26%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-2.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "1.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "2.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "-0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "1.9%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "2.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "9.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "38.78%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "0.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "6.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-9.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "9.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "5.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "-0.5%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "15.91%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "6.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "5.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-11.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-6.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "3.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-3.6%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "2.1%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.0%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-5.6%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "10.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "4.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-6.4%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "-0.2%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-3.16%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-13.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-10.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "-0.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-14.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "8.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "15.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "-1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "5.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "1.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "5.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "3.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-4.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "-1.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "4.3%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "-1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "7.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "6.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "-0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-4.5%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-1.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-3.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "52.32%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "18.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "5.0%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "1.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "4.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "6.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "2.40%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-14.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "-0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "-1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "9.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "5.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "1.6%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-2.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "1.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "13.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "6.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "17.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "4.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-2.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "-4.3%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-2.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "6.6%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-2.4%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-1.2%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "-18.01%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-2.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-2.0%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "4.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "2.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "2.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-11.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-6.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-11.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-11.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "9.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "-10.8%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "2.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "52.92%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-3.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "6.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-7.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-20.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-14.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "-4.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "18.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "7.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "7.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "-2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "5.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-7.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-4.6%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "6.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "49.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "20.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "6.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "7.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "13.9%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-4.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "-3.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "2.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "-3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "-0.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "11.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "54.32%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-6.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "11.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "9.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "6.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "11.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "5.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-4.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "1.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.5%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "12.78%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-4.8%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-0.9%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "3.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "1.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-13.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-11.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-4.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-6.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "11.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "4.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.0%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "14.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-0.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-8.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "7.7%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "34.07%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-20.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "-2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-8.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "-7.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "-0.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "11.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "2.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "0.7%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "3.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "15.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "4.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "5.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "5.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "21.40%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "6.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "8.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-4.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-8.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-4.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "0.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "4.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "3.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.1%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-5.80%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-13.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-9.7%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-0.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-11.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-6.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-5.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "9.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-3.0%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "1.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-0.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "3.3%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "l_50_10_26",
      ytds: [
        {
          year: 2011,
          ytd_data: "-47.99%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-8.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "6.2%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-4.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "3.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "3.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "-1.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "-5.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-16.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-7.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-8.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "8.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-4.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "5.6%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "-1.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-16.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-5.5%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-13.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "7.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-6.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-6.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "69.76%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "58.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "9.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "15.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "8.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "10.7%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "3.9%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-8.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-0.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-3.7%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-10.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-5.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-3.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "0.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "0.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-5.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "14.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "6.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "3.4%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "-9.69%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-4.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-10.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-6.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "-3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "13.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "3.0%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "5.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-9.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "-4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-1.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-28.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "-1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-7.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-16.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "-3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "18.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "5.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "11.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "0.3%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "2.1%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "3.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "3.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "10.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "70.00%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "-0.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "13.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "4.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-9.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "-0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "0.8%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "20.00%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "4.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-5.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "0.7%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-2.4%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-6.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "4.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.3%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "-5.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-4.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "-1.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "20.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "14.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "6.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-6.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "1.9%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-12.42%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-5.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-6.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-9.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "4.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-4.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "9.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.3%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "4.3%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "3.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-1.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "-1.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-5.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "0.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "1.2%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "39.92%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "2.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "1.6%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "6.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-3.96%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-10.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "0.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "2.9%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-6.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "8.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "6.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-2.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-8.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-6.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "12.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "-3.3%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-4.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "6.0%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "1.6%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-0.4%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "-2.44%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "-1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-2.0%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "9.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-0.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "1.9%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "4.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "3.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "6.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "4.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "4.1%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "1.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-11.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "-0.0%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "7.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "-8.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-9.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "17.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "-3.3%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "13.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "11.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "120.35%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-6.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-21.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-10.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "-6.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "21.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "7.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "8.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "-2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "6.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-7.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-3.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "5.8%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "57.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "25.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "8.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "9.2%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "8.1%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "1.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "-4.6%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "2.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "-3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "17.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "4.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "25.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "7.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "68.26%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "22.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "11.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "7.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "14.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "9.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "7.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-11.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-9.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-6.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "2.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "3.0%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "15.31%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-4.5%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "2.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-9.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-4.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "-1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "5.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "-3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "4.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-4.2%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-4.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "0.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-4.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "1.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "13.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "-0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "9.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "3.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "9.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-4.6%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "2.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-3.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "9.4%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "66.20%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-6.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "1.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "-0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "3.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "10.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "6.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "4.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "-2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "-1.2%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "1.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "6.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "17.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "3.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "8.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "49.33%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "11.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "8.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "5.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-6.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "0.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "4.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "-0.0%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "19.29%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-6.1%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "6.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "0.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-13.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-7.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-6.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "10.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "5.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "6.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "-1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "0.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "5.2%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "1.7%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "10.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "9.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "l_50_10_52",
      ytds: [
        {
          year: 2011,
          ytd_data: "-38.83%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-1.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "4.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "1.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "0.5%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-21.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-8.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-12.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "5.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "10.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-5.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-3.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "6.1%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "-1.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-15.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-5.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-13.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "5.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-14.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-6.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-9.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "0.3%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "36.42%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "47.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "10.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "13.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "2.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "9.8%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "4.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "-5.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "-3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "0.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-1.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-6.0%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-5.3%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-4.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "16.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "5.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "3.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "6.9%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "3.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "4.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "19.21%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-0.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "1.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-3.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "0.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "1.6%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "3.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "-0.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-3.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "7.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "1.9%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "2.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "9.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "36.16%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "14.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "7.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-10.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "9.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "5.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "-0.1%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "18.95%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "6.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "5.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-5.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "2.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "3.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-3.6%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "2.1%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.0%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-5.6%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "9.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "3.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-6.4%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-0.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "-0.2%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-1.84%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-13.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-10.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "-0.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-14.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "9.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "13.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "5.4%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "1.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "5.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "3.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-4.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "-1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "4.0%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "7.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "6.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-4.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "-2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-1.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "3.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-3.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "2.1%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "48.29%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "16.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "4.1%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "0.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "5.0%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "7.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-0.22%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-14.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "-0.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "-1.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "1.6%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-2.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "14.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "7.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "16.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-2.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "-4.3%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-1.3%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-2.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "6.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-2.4%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-1.0%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "-15.97%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "1.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-2.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-2.0%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "4.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "2.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-13.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "-0.0%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-6.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-9.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-9.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "9.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "-10.8%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "2.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "50.15%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-3.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "6.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-7.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-19.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-11.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "-3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "18.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "6.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "8.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "-2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "5.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-7.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-4.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "6.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "48.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "20.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "8.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "5.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "14.1%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-4.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "0.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "-3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "2.5%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "-4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "-0.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "61.66%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-6.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "15.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "9.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "4.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "6.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "11.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "5.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "1.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.6%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "8.84%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-4.8%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-0.9%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "3.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "1.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-14.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-11.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-4.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-7.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "2.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "13.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "4.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.0%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "14.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-1.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-8.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "7.7%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "33.02%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-20.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "-2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-1.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-8.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "-7.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "0.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "10.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "5.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "1.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "0.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "3.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "5.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "21.32%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "6.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "8.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-4.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-7.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "0.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-4.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "2.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "2.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "3.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.6%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-9.10%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-14.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-8.8%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-6.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-0.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-14.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-7.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-6.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "8.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-4.5%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "4.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "0.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-0.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "3.4%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "md_25_10_26",
      ytds: [
        {
          year: 2011,
          ytd_data: "-13.65%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-1.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "0.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "1.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "2.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "1.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "-0.4%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "1.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-3.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "1.3%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "0.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "5.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "29.72%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "10.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "5.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-0.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "3.4%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-3.6%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "1.3%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "0.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "3.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "4.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "10.64%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-4.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "0.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-7.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "1.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "1.8%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "6.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "3.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "4.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "2.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "0.6%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "3.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "0.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "11.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "76.88%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "13.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "15.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "5.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-10.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "3.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "-1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "2.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "0.6%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "8.31%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "2.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "4.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-13.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-6.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "3.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "2.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-3.0%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "0.4%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "0.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-5.2%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-3.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "0.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "1.0%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-10.23%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-10.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-2.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-7.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-7.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "5.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.3%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "-1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "3.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "0.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "3.3%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-0.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "3.9%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "7.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-6.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-4.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-2.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "4.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "1.2%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "40.34%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "13.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "4.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "2.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "3.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "6.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-12.55%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-11.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-10.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "1.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "1.6%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.2%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "3.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "5.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "4.5%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-1.4%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-1.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "2.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-0.6%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "7.85%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-0.9%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-2.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "-0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "1.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "4.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "0.2%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "0.4%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "3.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "30.94%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-6.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-13.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "-6.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "18.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "13.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "-0.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "1.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "0.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-0.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "4.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "-1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "18.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "77.27%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "7.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-4.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "20.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "10.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "12.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "7.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "4.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "7.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "14.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "9.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-9.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-5.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "2.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "26.86%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "2.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-2.8%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "-1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "11.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "6.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "0.5%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-4.0%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-10.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "5.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-6.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "4.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "4.3%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.3%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "14.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "5.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-4.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "0.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-3.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "8.7%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "54.36%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-7.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-5.8%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-4.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "-0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "-0.4%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "5.3%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "4.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "9.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "1.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "19.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "5.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "8.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "41.45%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "4.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "10.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "13.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "8.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "5.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-6.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-2.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "0.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "5.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.3%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-15.40%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-17.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-7.8%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-4.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-4.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-7.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-5.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-6.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "7.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-2.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "0.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-2.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "md_25_10_52",
      ytds: [
        {
          year: 2011,
          ytd_data: "-19.30%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-15.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "1.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "0.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-4.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "4.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-4.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-4.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "0.0%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "45.53%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "12.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "3.6%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "5.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "-0.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "1.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-2.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "0.3%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-1.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "0.4%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "1.9%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-0.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "3.4%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "-0.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "8.34%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "-0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-4.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "0.6%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "3.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "4.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "4.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "1.9%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "1.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "10.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "48.42%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "0.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "17.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "6.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "7.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-9.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "8.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "8.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "4.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "1.4%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "16.21%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "5.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-11.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-6.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "3.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "3.3%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-2.4%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-4.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "6.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.7%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-6.4%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "4.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "0.3%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-0.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-2.6%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "1.1%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-3.95%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-6.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-8.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-4.6%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "4.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "-1.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "1.7%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "2.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "0.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "2.7%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "5.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-5.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "-3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "5.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-2.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "2.3%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "34.51%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "13.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "4.8%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "-0.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "5.5%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "7.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "0.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-9.13%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-14.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-6.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "2.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "11.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "7.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "2.8%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "5.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "2.8%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-7.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-1.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "0.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-1.3%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-1.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "4.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-2.4%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-0.4%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "5.29%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "1.6%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-0.4%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "2.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "2.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-1.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "4.3%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "1.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "3.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "25.51%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "6.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-4.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-16.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "-8.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "13.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "13.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "0.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-0.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "-0.6%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "-0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-1.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "2.9%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "5.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "16.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "49.43%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-5.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "7.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "10.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "11.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "6.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "4.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "10.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "6.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "6.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-4.6%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "1.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.5%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "17.12%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-2.6%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "0.1%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "1.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "1.6%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-14.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-3.7%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-10.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-6.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "3.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "16.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-3.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-4.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "7.7%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "34.96%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "-2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-7.9%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "2.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "0.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "0.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "4.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "3.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "13.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "5.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "19.52%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-8.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "4.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "11.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "6.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "8.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "7.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-7.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-4.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-8.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-1.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "-0.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "3.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.1%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-5.18%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-15.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-9.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "-2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-0.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-9.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-5.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-5.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "8.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "-0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-3.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "0.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-1.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "5.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "2.6%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "md_50_10_26",
      ytds: [
        {
          year: 2011,
          ytd_data: "-17.08%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.2%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-0.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.2%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "0.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "1.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "0.4%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "-0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "0.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-3.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "1.3%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "0.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "5.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "33.40%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "10.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "5.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-0.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-1.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-3.6%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "0.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "4.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "15.84%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-4.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-6.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "1.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "2.6%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "4.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "4.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "4.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "4.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "2.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "0.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "10.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "71.78%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "-0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "4.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "13.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "14.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "5.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-10.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "6.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "-0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "2.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "0.5%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "7.14%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "4.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-5.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "0.7%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "5.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "0.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-5.2%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "2.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-3.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-1.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "2.4%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-13.64%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-10.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-2.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-6.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "5.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.3%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "-1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "3.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "3.7%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "3.9%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "6.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-5.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "0.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "1.2%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "36.73%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "12.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "4.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "2.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "3.4%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "-1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-8.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "6.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-12.44%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-10.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-10.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "0.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "1.9%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "3.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-1.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-10.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-8.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "5.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-1.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "5.3%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-1.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-2.3%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-0.6%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "7.62%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-1.1%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-2.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "2.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "2.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-10.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-2.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "0.2%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "3.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "38.60%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-6.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "-6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "18.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "13.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "-0.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "1.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "-0.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "0.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "0.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "4.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "23.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "69.09%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "22.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "11.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "7.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "14.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "9.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "7.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-11.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-9.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-6.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "2.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "24.21%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "2.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "-1.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "10.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "0.6%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-11.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-3.9%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-11.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "5.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "12.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "4.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "5.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-4.6%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "0.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-3.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "9.4%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "50.98%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-6.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "1.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "-0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-4.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "-0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "-1.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "5.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "6.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "16.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "7.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "53.72%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "11.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "8.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "5.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-6.1%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "0.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "4.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.4%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-15.35%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-16.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-7.8%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-4.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-5.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-4.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "6.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-3.0%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "-0.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "-0.7%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-2.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "md_50_10_52",
      ytds: [
        {
          year: 2011,
          ytd_data: "-19.10%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.7%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "4.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "1.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "1.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "1.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "0.5%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "0.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-4.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "4.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-6.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-4.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "0.0%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "44.79%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "10.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "3.1%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "3.5%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "0.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "1.3%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "-0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "1.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "3.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "4.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "21.62%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-0.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "1.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "0.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "1.4%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "3.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "-0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-3.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "2.5%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "1.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "28.44%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "0.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "12.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "7.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-11.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "8.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "5.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "0.5%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "12.75%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "2.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "6.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "5.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-11.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-5.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "3.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-3.6%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.2%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-6.3%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "4.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-2.6%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "1.6%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-6.40%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-8.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "6.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "-1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "1.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-0.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "2.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "-0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "1.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "3.3%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "6.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-5.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "-3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-1.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "51.97%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "16.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "5.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "-0.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "4.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "0.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "7.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-8.47%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-10.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-14.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "0.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "1.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "6.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "2.1%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-2.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-7.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "3.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-2.4%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "1.9%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "4.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "0.1%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "5.82%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "1.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-0.6%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-1.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "1.5%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "2.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "1.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "-0.0%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-1.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "1.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "4.3%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "2.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "26.01%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-3.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "6.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-7.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-18.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "-9.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "14.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "13.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-0.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "-0.1%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "-0.4%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "-0.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "1.5%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-0.9%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "-2.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "3.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "5.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "17.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "59.24%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-6.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "13.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "8.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "6.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "5.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "6.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "1.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.6%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "11.36%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-4.8%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "1.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-0.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-2.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "3.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "10.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "3.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-15.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-3.8%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-11.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-4.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-7.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "12.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "3.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.9%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "15.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-3.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-4.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-8.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "7.7%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "37.74%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-13.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "-2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-7.9%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "-1.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "-0.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "4.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "13.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "5.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "5.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "18.83%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "6.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "8.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-4.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-7.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-8.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-0.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "2.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "2.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.1%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-4.53%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-9.1%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-6.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "0.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-10.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-4.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "8.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "-0.2%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-3.5%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "5.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "0.7%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "3.3%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "ml_25_10_26",
      ytds: [
        {
          year: 2011,
          ytd_data: "-38.86%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-10.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-1.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-8.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "4.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "3.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "4.1%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "2.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "-2.7%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-19.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-8.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-8.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-4.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "5.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "9.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-1.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-4.3%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "5.6%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "-0.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-15.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-5.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-13.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "7.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-9.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-6.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-6.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "0.5%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "79.33%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "55.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "9.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "15.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "7.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "10.0%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "3.5%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-0.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-1.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "3.4%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-3.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-3.7%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-9.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-5.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "3.3%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "6.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-5.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "15.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "3.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "6.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "4.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "-21.11%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-4.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-9.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "0.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-6.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "-3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "14.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "4.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-10.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "-4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-1.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-28.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "-2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-7.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-16.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "2.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "14.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "-1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "3.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "2.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "11.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "72.07%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "-0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "-0.6%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "13.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "15.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "5.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-10.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "3.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "-1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "1.5%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "10.84%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "4.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-13.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-6.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "0.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-2.8%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "-5.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-3.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "5.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "3.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "2.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.7%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-7.7%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "1.0%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-11.74%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-5.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-8.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "1.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-10.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "4.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "9.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.4%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "2.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "3.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "3.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "2.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-3.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "-1.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "2.5%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-6.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-4.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-2.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "4.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "1.2%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "35.82%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "9.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "2.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "1.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-6.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "6.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-4.80%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-10.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "1.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "2.8%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.2%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-6.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "8.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "6.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-7.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "8.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-6.8%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "14.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-2.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "-3.2%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-4.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "7.4%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-0.4%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-0.8%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "-13.47%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "-1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-4.9%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-1.1%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "0.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "3.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "0.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "1.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-11.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "0.8%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-3.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "-0.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "7.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "-8.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-9.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "14.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "-4.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "12.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "12.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "65.84%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-6.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-21.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-11.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "-5.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "30.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "8.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "9.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "-0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "9.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-7.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-3.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "6.3%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "46.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "16.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "8.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "9.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "7.9%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "1.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "-5.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "-2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "0.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "-1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "14.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "79.79%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "7.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-4.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "20.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "9.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "12.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "7.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "14.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "9.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-9.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-7.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-5.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "2.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "15.52%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "2.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-9.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-2.9%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "-2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "-3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "4.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "-0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-5.2%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-6.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-8.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "2.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "11.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "3.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "10.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "0.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-2.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "8.7%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "66.45%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-6.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "-0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-7.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "9.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "6.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "5.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "-3.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "-0.5%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "3.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "-5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "9.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "1.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "19.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "5.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "7.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "42.02%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "4.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "10.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "12.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "8.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-7.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "5.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-6.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-2.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "2.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "0.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "5.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.3%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "8.31%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-6.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-13.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-8.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-7.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "7.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "-0.7%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-3.0%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "3.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "2.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "10.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "9.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "ml_25_10_26_Live",
      ytds: [
        {
          year: 2011,
          ytd_data: "-16.26%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.7%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.9%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-0.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "1.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "2.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "-0.4%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "1.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "1.5%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "0.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "2.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-5.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "27.66%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "9.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "2.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "5.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-0.5%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-1.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-3.6%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "1.3%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "1.3%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "1.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "3.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "4.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "7.17%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-9.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-4.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-6.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "1.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "2.6%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "5.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "0.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "2.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "0.6%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "3.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "0.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "10.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "76.31%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "-0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "15.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "5.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-10.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "2.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "0.6%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "4.51%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "7.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "2.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "3.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-13.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-7.1%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-3.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "0.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-2.1%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "4.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "0.3%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-5.2%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "0.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "1.0%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-18.95%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-11.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-2.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-8.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-8.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "5.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "1.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "-0.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "3.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "0.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "2.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-0.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "3.2%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "4.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-6.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-10.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "-3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-4.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "-0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-3.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "4.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-4.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "37.88%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "14.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "4.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "2.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "3.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "4.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "4.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-15.70%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-10.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "2.8%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.2%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-2.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "3.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-1.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-10.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-7.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-6.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "5.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-2.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "2.3%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "4.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-0.3%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "6.81%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "2.7%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-0.9%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "0.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "1.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "1.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-11.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-2.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "0.2%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "0.4%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "3.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "49.94%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-6.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "4.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "19.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "14.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "2.3%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "-0.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "2.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "4.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "-1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "16.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.6%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "82.80%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "7.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-4.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "20.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "10.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "7.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "7.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "14.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "9.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-9.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-6.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "2.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "17.57%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-2.5%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "3.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-2.9%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-3.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "-0.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "4.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "0.5%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-17.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-5.1%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-10.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "-0.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-5.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "1.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "14.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "5.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-4.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "2.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "8.4%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "57.62%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-5.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "0.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "4.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "-0.6%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "5.7%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "4.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "9.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "18.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "5.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "7.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "40.26%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "4.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "9.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "12.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "8.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-7.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "5.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-6.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "3.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "0.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "5.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.3%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-16.13%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-19.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-7.8%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "-4.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-4.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-4.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-5.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "6.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "-0.0%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-3.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "0.5%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-2.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "-0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "ml_25_10_52",
      ytds: [
        {
          year: 2011,
          ytd_data: "-45.03%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-16.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-5.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "3.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "12.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.5%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "-1.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "-2.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-21.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-7.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-4.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-11.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "9.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-3.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-3.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "6.4%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "-0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-16.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-5.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-14.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "6.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-12.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-6.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-8.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "0.1%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "41.79%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "48.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "10.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "14.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "2.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "11.9%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "3.5%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-9.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "-4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-0.4%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-5.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-2.9%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-10.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-8.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "15.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "6.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "3.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "4.7%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-9.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-6.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "9.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "3.4%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "-0.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "-19.65%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-4.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "-3.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "10.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "3.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "1.5%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "1.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-12.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "-5.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-2.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-20.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-7.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-13.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "10.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "-0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "1.9%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "2.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "10.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "47.49%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "17.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "7.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-9.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "8.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "8.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "4.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "1.4%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "11.83%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-2.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "5.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-11.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-6.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "0.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "3.3%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-5.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.7%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-3.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "9.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "3.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-0.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-6.4%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-4.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "0.8%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-0.52%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-13.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-9.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "-0.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-13.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "7.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "13.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.4%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "0.7%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "5.0%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "2.5%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "4.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "2.7%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "0.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-3.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "0.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "-0.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "5.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "4.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-4.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-0.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "5.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-2.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "1.0%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "30.22%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "9.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "3.6%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "-0.2%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "1.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "7.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-0.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "0.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "3.44%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-14.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-6.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "2.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "5.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "1.2%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "5.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "2.6%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "-1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "10.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "13.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "6.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "17.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-2.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "-4.3%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "0.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-4.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "4.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-2.5%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-1.0%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "-15.71%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-3.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-2.2%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-2.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "5.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "2.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-13.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "-0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-6.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "1.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "7.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "-10.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-9.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "14.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "0.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "9.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "8.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "62.48%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "6.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-4.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-24.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-10.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-10.6%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "-3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "24.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "6.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "11.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "6.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-7.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-4.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "7.0%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "45.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "17.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "6.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "7.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "11.0%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-1.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "-3.3%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "4.2%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "-3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "1.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "10.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "56.20%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "12.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "7.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "11.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "5.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "10.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "4.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "11.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "6.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "5.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-4.6%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "1.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.5%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "15.51%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-2.6%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "0.1%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "-1.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "-2.4%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "3.5%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-10.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-5.3%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-7.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-6.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "11.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "4.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "2.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "1.5%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "16.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "1.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-2.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "7.7%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "31.15%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-16.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "-2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-8.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-1.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "-0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "9.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "4.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "0.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "0.9%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "3.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "3.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "14.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "5.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "18.90%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-8.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "4.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "10.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "6.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "8.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "7.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-7.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-10.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-4.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-8.0%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-1.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "-1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-4.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "1.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "5.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.3%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "10.39%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-6.4%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "5.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-12.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-8.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-5.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "9.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "0.0%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-0.8%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "3.5%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "1.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "7.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "ml_50_10_26",
      ytds: [
        {
          year: 2011,
          ytd_data: "-44.68%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.2%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-8.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "9.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-4.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "-1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "3.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "2.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "2.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "-0.4%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "-2.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "-2.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-17.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-7.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-8.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "9.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-4.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "5.6%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "-1.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-17.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-5.8%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-13.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "7.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-6.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-6.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "3.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "81.05%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "58.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "9.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "15.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "8.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "10.7%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "3.9%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-0.5%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-3.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-3.7%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-10.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-5.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-3.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "2.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "1.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-5.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "15.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "6.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "4.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "-17.58%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-4.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-10.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-6.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "-3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "13.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "3.0%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "5.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-9.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "-4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-1.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-28.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "-1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-7.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-16.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "-3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "4.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "14.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "9.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "-0.3%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "2.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "3.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "10.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "76.63%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "4.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "13.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "5.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-10.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "6.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "-0.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "0.8%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "11.62%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "4.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-5.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "2.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "0.7%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-2.4%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-6.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "4.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.3%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "-5.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-3.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "6.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-6.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "1.2%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-13.82%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-11.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-5.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-7.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-9.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "4.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-4.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "9.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.3%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "4.3%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-1.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "-1.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "4.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-5.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "0.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "1.2%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "30.27%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "2.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "1.6%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-8.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "6.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-4.42%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-10.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "0.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "2.9%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-1.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-6.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "8.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "6.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-1.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-8.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "6.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-3.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-5.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "13.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-1.6%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "-3.5%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-4.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "6.0%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-0.6%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "-12.81%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "-1.2%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-4.9%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-0.0%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-2.0%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-0.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "4.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "1.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-3.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "-0.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "7.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "-8.9%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-9.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "18.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "-3.3%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "13.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "12.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "79.18%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-6.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-23.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-12.2%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "-6.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "24.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "7.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "8.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "9.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-7.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-3.6%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "6.0%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "57.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "25.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "8.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "9.2%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "8.1%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "-4.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "2.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "-3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "3.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "20.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "69.94%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "22.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "11.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "7.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "14.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "9.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "7.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-11.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-9.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-6.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "2.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "17.44%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "2.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-2.9%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "-1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "5.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "-3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "4.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-6.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-5.2%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-7.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "4.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-5.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "1.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "2.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.0%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "3.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "9.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-1.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "2.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "0.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "9.4%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "66.38%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-7.0%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "1.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "-0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-5.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "5.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "10.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "4.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "-2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "1.7%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "-1.5%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "1.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "-5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "3.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "6.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "18.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "8.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "54.27%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "5.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "7.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "3.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "11.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "8.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "5.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-6.1%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "0.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "4.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.4%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "11.15%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-6.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "7.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-1.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-7.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-7.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "7.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "-1.5%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-3.2%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "11.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "3.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "10.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-1.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "9.4%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "ml_50_10_26_Live",
      ytds: [
        {
          year: 2011,
          ytd_data: "-11.77%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-2.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.7%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-0.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "4.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "7.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "4.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "4.6%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-0.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "0.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "1.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "0.4%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "-0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "0.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "4.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "3.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "1.5%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "0.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "-0.7%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "36.46%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "1.4%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "3.4%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "5.7%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-0.2%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-1.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "3.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-3.6%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-4.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "0.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "1.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "4.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "7.81%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-8.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "-0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-4.5%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-6.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "1.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "-3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "3.2%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "5.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-0.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "-0.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "0.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "2.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "0.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "9.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "64.06%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "-0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "12.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "6.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "9.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "5.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-8.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-10.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "-1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "2.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "0.5%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "6.57%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "3.3%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "7.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "3.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-6.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "0.7%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-2.4%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "4.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "0.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.3%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-5.2%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "2.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.4%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-1.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "2.4%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-19.05%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-2.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-7.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "0.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "6.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "1.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "3.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "0.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "2.9%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "-0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "1.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "3.2%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "4.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "5.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "1.6%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-5.7%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "-2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-4.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-2.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "4.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-4.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "0.8%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "36.59%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "14.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "4.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "3.5%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "2.0%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "3.4%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "-2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-7.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "4.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "4.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-9.48%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-10.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "-1.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "-1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-1.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "1.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "7.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "2.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "2.9%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-2.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "3.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-7.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "4.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-2.4%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "4.1%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "-0.6%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-1.6%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "2.1%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-1.9%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-0.2%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "7.04%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "1.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-1.1%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-0.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-0.9%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "0.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "1.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-7.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-2.4%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "0.0%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-2.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-1.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "0.2%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "0.5%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "3.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "59.74%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "5.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-6.9%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "1.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "4.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "16.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "11.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "1.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-1.1%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "2.3%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "-0.4%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "-0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "0.8%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "1.7%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-2.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "1.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "2.5%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-5.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "4.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "22.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "4.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "80.00%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "21.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "10.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "7.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "14.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "9.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "7.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-9.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "4.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "-1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-3.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-6.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "2.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "-1.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-0.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "1.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "14.54%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-2.5%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "3.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-2.9%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-3.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "-0.7%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "4.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "1.4%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "0.6%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.8%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "0.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-19.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-5.0%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-11.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "-0.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "2.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "12.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "2.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "2.7%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "13.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "5.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "3.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-4.6%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-3.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-9.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "8.4%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "52.98%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-6.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "1.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "-0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-1.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "4.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "2.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "0.3%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "-1.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "5.0%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "3.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "18.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "4.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "8.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "50.32%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "7.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "4.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "3.6%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "11.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "5.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "8.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "8.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-7.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "5.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-6.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "5.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "4.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "0.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "2.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "4.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.4%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "-19.65%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-19.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-7.8%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "-4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-5.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "-3.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-7.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-5.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "4.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "6.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "-0.0%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-4.1%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "-0.8%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-2.4%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "0.7%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "ml_50_10_52",
      ytds: [
        {
          year: 2011,
          ytd_data: "-45.29%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-12.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-01-03",
                  week_data: "-6.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-01-10",
                  week_data: "-1.6%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-01-17",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-01-24",
                  week_data: "-3.7%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-01-31",
                  week_data: "-1.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-02-07",
                  week_data: "-4.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-02-14",
                  week_data: "2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-02-21",
                  week_data: "-2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-02-28",
                  week_data: "3.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-03-07",
                  week_data: "0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-03-14",
                  week_data: "-0.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-03-21",
                  week_data: "4.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-03-28",
                  week_data: "3.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-04-04",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-04-11",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-04-18",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-04-25",
                  week_data: "-3.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-05-02",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-05-09",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-05-16",
                  week_data: "-0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-05-23",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-05-30",
                  week_data: "1.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-06-06",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-06-13",
                  week_data: "-0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-06-20",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-06-27",
                  week_data: "2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-07-04",
                  week_data: "1.5%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-07-11",
                  week_data: "0.3%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-07-18",
                  week_data: "0.5%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-07-25",
                  week_data: "-1.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-21.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-08-01",
                  week_data: "-7.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-08-08",
                  week_data: "-4.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-08-15",
                  week_data: "-12.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-08-22",
                  week_data: "-3.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-08-29",
                  week_data: "5.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-09-05",
                  week_data: "10.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-09-12",
                  week_data: "0.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-09-19",
                  week_data: "-5.2%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-09-26",
                  week_data: "-1.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-10-03",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-10-10",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-10-17",
                  week_data: "-3.9%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-10-24",
                  week_data: "6.1%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2011-10-31",
                  week_data: "-1.1%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-18.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-11-07",
                  week_data: "-5.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-11-14",
                  week_data: "-15.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-11-21",
                  week_data: "-2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-11-28",
                  week_data: "5.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-14.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2011-12-05",
                  week_data: "-6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2011-12-12",
                  week_data: "-9.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2011-12-19",
                  week_data: "0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2011-12-26",
                  week_data: "0.3%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "32.63%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "47.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-01-02",
                  week_data: "10.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-01-09",
                  week_data: "13.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-01-16",
                  week_data: "2.7%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-01-23",
                  week_data: "9.8%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-01-30",
                  week_data: "4.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-02-06",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-02-13",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-02-20",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-02-27",
                  week_data: "0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-7.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-03-05",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-03-12",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-03-19",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-03-26",
                  week_data: "-1.3%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-9.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-04-02",
                  week_data: "2.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-04-09",
                  week_data: "-2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-04-16",
                  week_data: "-0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-04-23",
                  week_data: "-4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-04-30",
                  week_data: "-4.2%",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-13.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-05-07",
                  week_data: "-8.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-05-14",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-05-21",
                  week_data: "0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-05-28",
                  week_data: "-3.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "14.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-06-04",
                  week_data: "6.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-06-11",
                  week_data: "-0.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-06-18",
                  week_data: "3.4%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-06-25",
                  week_data: "5.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-07-02",
                  week_data: "4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-07-09",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-07-16",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-07-23",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-07-30",
                  week_data: "2.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-08-06",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-08-13",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-08-20",
                  week_data: "-3.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-08-27",
                  week_data: "-5.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "10.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-09-03",
                  week_data: "3.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-09-10",
                  week_data: "6.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-09-17",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-09-24",
                  week_data: "1.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-10-01",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-10-08",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-10-15",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-10-22",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-10-29",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-11-05",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-11-12",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-11-19",
                  week_data: "0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-11-26",
                  week_data: "4.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2012-12-31",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2012-12-03",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2012-12-10",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2012-12-17",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2012-12-24",
                  week_data: "-0.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "-6.22%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-01-07",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-01-14",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-01-21",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-01-28",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-02-04",
                  week_data: "-0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-02-11",
                  week_data: "-0.0%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-02-18",
                  week_data: "1.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-02-25",
                  week_data: "-2.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-03-04",
                  week_data: "3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-03-11",
                  week_data: "0.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-03-18",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-03-25",
                  week_data: "-2.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-04-01",
                  week_data: "1.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-04-08",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-04-15",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-04-22",
                  week_data: "1.3%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-04-29",
                  week_data: "2.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-05-06",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-05-13",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-05-20",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-05-27",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-9.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-06-03",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-06-10",
                  week_data: "-6.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-06-17",
                  week_data: "-4.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-06-24",
                  week_data: "-1.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-17.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-07-01",
                  week_data: "3.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-07-08",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-07-15",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-07-22",
                  week_data: "-6.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-07-29",
                  week_data: "-13.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-08-05",
                  week_data: "0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-08-12",
                  week_data: "-1.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-08-19",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-08-26",
                  week_data: "3.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-09-02",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-09-09",
                  week_data: "2.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-09-16",
                  week_data: "0.2%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-09-23",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-09-30",
                  week_data: "1.9%",
                  regime: "100",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-10-07",
                  week_data: "4.2%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-10-14",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-10-21",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-10-28",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-11-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-11-11",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-11-18",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-11-25",
                  week_data: "3.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "9.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2013-12-30",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2013-12-02",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2013-12-09",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2013-12-16",
                  week_data: "5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2013-12-23",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "30.05%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-01-06",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-01-13",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-01-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-01-27",
                  week_data: "0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-02-03",
                  week_data: "0.9%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-02-10",
                  week_data: "0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-02-17",
                  week_data: "3.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-02-24",
                  week_data: "0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-03-03",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-03-10",
                  week_data: "-2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-03-17",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-03-24",
                  week_data: "1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-03-31",
                  week_data: "1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-04-07",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-04-14",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-04-21",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-04-28",
                  week_data: "-2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-05-05",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-05-12",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-05-19",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-05-26",
                  week_data: "-2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "12.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-06-02",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-06-09",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-06-16",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-06-23",
                  week_data: "3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-06-30",
                  week_data: "7.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-07-07",
                  week_data: "-11.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-07-14",
                  week_data: "8.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-07-21",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-07-28",
                  week_data: "1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-08-04",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-08-11",
                  week_data: "1.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-08-18",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-08-25",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-09-01",
                  week_data: "7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-09-08",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-09-15",
                  week_data: "-3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-09-22",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-09-29",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-10-06",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-10-13",
                  week_data: "-0.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-10-20",
                  week_data: "5.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-10-27",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-11-03",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-11-10",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-11-17",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-11-24",
                  week_data: "1.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2014-12-29",
                  week_data: "3.0%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2014-12-01",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2014-12-08",
                  week_data: "-4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2014-12-15",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2014-12-22",
                  week_data: "0.5%",
                  regime: "011",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "-0.82%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-01-05",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-01-12",
                  week_data: "2.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-01-19",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-01-26",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-02-02",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-02-09",
                  week_data: "6.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-02-16",
                  week_data: "2.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-02-23",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-03-02",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-03-09",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-03-16",
                  week_data: "-1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-03-23",
                  week_data: "-2.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-03-30",
                  week_data: "5.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-11.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-04-06",
                  week_data: "1.8%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-04-13",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-04-20",
                  week_data: "-5.8%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-04-27",
                  week_data: "-1.4%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-05-04",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-05-11",
                  week_data: "0.8%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-05-18",
                  week_data: "1.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-05-25",
                  week_data: "3.1%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-06-01",
                  week_data: "-3.6%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-06-08",
                  week_data: "-7.3%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-06-15",
                  week_data: "2.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-06-22",
                  week_data: "1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-06-29",
                  week_data: "1.4%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-07-06",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-07-13",
                  week_data: "3.2%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-07-20",
                  week_data: "-2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-07-27",
                  week_data: "-1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-7.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-08-03",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-08-10",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-08-17",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-08-24",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-08-31",
                  week_data: "-4.5%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "9.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-09-07",
                  week_data: "1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-09-14",
                  week_data: "5.0%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-09-21",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-09-28",
                  week_data: "3.7%",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-10-05",
                  week_data: "-0.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-10-12",
                  week_data: "2.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-10-19",
                  week_data: "0.2%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-10-26",
                  week_data: "-1.6%",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-11-02",
                  week_data: "-6.4%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-11-09",
                  week_data: "-1.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-11-16",
                  week_data: "2.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-11-23",
                  week_data: "1.9%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2015-11-30",
                  week_data: "-2.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2015-12-07",
                  week_data: "-3.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2015-12-14",
                  week_data: "2.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2015-12-21",
                  week_data: "2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2015-12-28",
                  week_data: "-0.2%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "-4.62%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-13.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-01-04",
                  week_data: "-4.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-01-11",
                  week_data: "-10.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-01-18",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-01-25",
                  week_data: "-0.3%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-02-01",
                  week_data: "-1.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-02-08",
                  week_data: "-14.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-02-15",
                  week_data: "7.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-02-22",
                  week_data: "-2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-02-29",
                  week_data: "12.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "9.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-03-07",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-03-14",
                  week_data: "1.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-03-21",
                  week_data: "5.0%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-03-28",
                  week_data: "2.2%",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-04-04",
                  week_data: "-0.6%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-04-11",
                  week_data: "5.0%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-04-18",
                  week_data: "3.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-04-25",
                  week_data: "0.3%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-05-02",
                  week_data: "-4.9%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-05-09",
                  week_data: "-0.7%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-05-16",
                  week_data: "-1.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-05-23",
                  week_data: "1.6%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-05-30",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-06-06",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-06-13",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-06-20",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-06-27",
                  week_data: "5.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-07-04",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-07-11",
                  week_data: "1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-07-18",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-07-25",
                  week_data: "3.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-08-01",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-08-08",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-08-15",
                  week_data: "6.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-08-22",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-08-29",
                  week_data: "2.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-09-05",
                  week_data: "-5.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-09-12",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-09-19",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-09-26",
                  week_data: "-2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-10-03",
                  week_data: "2.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-10-10",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-10-17",
                  week_data: "0.3%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-10-24",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2016-10-31",
                  week_data: "-4.5%",
                  regime: "011",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-11-07",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-11-14",
                  week_data: "-2.3%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-11-21",
                  week_data: "2.7%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-11-28",
                  week_data: "-1.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2016-12-05",
                  week_data: "3.8%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2016-12-12",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2016-12-19",
                  week_data: "-5.8%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2016-12-26",
                  week_data: "1.1%",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "43.19%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "10.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-01-02",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-01-09",
                  week_data: "4.6%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-01-16",
                  week_data: "-0.3%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-01-23",
                  week_data: "1.6%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-01-30",
                  week_data: "2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-02-06",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-02-13",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-02-20",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-02-27",
                  week_data: "-1.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-03-06",
                  week_data: "-2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-03-13",
                  week_data: "3.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-03-20",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-03-27",
                  week_data: "1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-04-03",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-04-10",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-04-17",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-04-24",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-3.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-05-01",
                  week_data: "-1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-05-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-05-15",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-05-22",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-05-29",
                  week_data: "0.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-06-05",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-06-12",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-06-19",
                  week_data: "-4.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-06-26",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-07-03",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-07-10",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-07-17",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-07-24",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-07-31",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-08-07",
                  week_data: "-5.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-08-14",
                  week_data: "7.4%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-08-21",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-08-28",
                  week_data: "5.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-09-04",
                  week_data: "-0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-09-11",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-09-18",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-09-25",
                  week_data: "-0.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-10-02",
                  week_data: "1.5%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-10-09",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-10-16",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-10-23",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2017-10-30",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-11-06",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-11-13",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-11-20",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-11-27",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2017-12-04",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2017-12-11",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2017-12-18",
                  week_data: "2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2017-12-25",
                  week_data: "0.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "2.00%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-10.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-01-01",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-01-08",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-01-15",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-01-22",
                  week_data: "2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-01-29",
                  week_data: "-14.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-02-05",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-02-12",
                  week_data: "0.1%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-02-19",
                  week_data: "0.6%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-02-26",
                  week_data: "1.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-03-05",
                  week_data: "-3.4%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-03-12",
                  week_data: "0.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-03-19",
                  week_data: "-2.9%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-03-26",
                  week_data: "-0.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-04-02",
                  week_data: "6.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-04-09",
                  week_data: "1.0%",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-04-16",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-04-23",
                  week_data: "5.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-04-30",
                  week_data: "-3.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-05-07",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-05-14",
                  week_data: "-3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-05-21",
                  week_data: "3.1%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-05-28",
                  week_data: "-2.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-06-04",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-06-11",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-06-18",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-06-25",
                  week_data: "-1.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-07-02",
                  week_data: "-1.3%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-07-09",
                  week_data: "-3.5%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-07-16",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-07-23",
                  week_data: "10.3%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-07-30",
                  week_data: "2.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-08-06",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-08-13",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-08-20",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-08-27",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-09-03",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-09-10",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-09-17",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-09-24",
                  week_data: "-0.8%",
                  regime: "001",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "14.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-10-01",
                  week_data: "-5.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-10-08",
                  week_data: "7.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-10-15",
                  week_data: "-0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-10-22",
                  week_data: "-2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-10-29",
                  week_data: "16.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-6.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-11-05",
                  week_data: "3.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-11-12",
                  week_data: "-3.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-11-19",
                  week_data: "-2.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-11-26",
                  week_data: "-4.3%",
                  regime: "100",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2018-12-31",
                  week_data: "0.8%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2018-12-03",
                  week_data: "-3.8%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2018-12-10",
                  week_data: "4.4%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2018-12-17",
                  week_data: "-3.3%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2018-12-24",
                  week_data: "-1.0%",
                  regime: "100",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "-15.26%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-01-07",
                  week_data: "0.6%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-01-14",
                  week_data: "-1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-01-21",
                  week_data: "-2.6%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-01-28",
                  week_data: "-2.0%",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-02-04",
                  week_data: "-3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-02-11",
                  week_data: "-2.2%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-02-18",
                  week_data: "3.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-02-25",
                  week_data: "4.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-03-04",
                  week_data: "1.3%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-03-11",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-03-18",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-03-25",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-04-01",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-04-08",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-04-15",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-04-22",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-04-29",
                  week_data: "-0.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-05-06",
                  week_data: "-4.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-05-13",
                  week_data: "2.9%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-05-20",
                  week_data: "2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-05-27",
                  week_data: "0.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-06-03",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-06-10",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-06-17",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-06-24",
                  week_data: "2.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-14.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-07-01",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-07-08",
                  week_data: "-6.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-07-15",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-07-22",
                  week_data: "-0.0%",
                  regime: "001",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-07-29",
                  week_data: "-8.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-08-05",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-08-12",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-08-19",
                  week_data: "-2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-08-26",
                  week_data: "-0.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-13.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-09-02",
                  week_data: "-2.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-09-09",
                  week_data: "8.5%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-09-16",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-09-23",
                  week_data: "-10.8%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-09-30",
                  week_data: "-9.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "16.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-10-07",
                  week_data: "-0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-10-14",
                  week_data: "12.1%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-10-21",
                  week_data: "-5.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-10-28",
                  week_data: "10.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-11-04",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-11-11",
                  week_data: "1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-11-18",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-11-25",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2019-12-30",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2019-12-02",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2019-12-09",
                  week_data: "-2.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2019-12-16",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2019-12-23",
                  week_data: "0.5%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "51.24%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-01-06",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-01-13",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-01-20",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-01-27",
                  week_data: "-3.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-02-03",
                  week_data: "6.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-02-10",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-02-17",
                  week_data: "-0.5%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-02-24",
                  week_data: "-7.1%",
                  regime: "011",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-24.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-03-02",
                  week_data: "-2.2%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-03-09",
                  week_data: "-8.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-03-16",
                  week_data: "0.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-03-23",
                  week_data: "-11.7%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-03-30",
                  week_data: "-4.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "22.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-04-06",
                  week_data: "6.0%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-04-13",
                  week_data: "11.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-04-20",
                  week_data: "-1.5%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-04-27",
                  week_data: "5.1%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-05-04",
                  week_data: "-7.9%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-05-11",
                  week_data: "1.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-05-18",
                  week_data: "-4.5%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-05-25",
                  week_data: "6.7%",
                  regime: "100",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "45.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-06-01",
                  week_data: "20.0%",
                  regime: "100",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-06-08",
                  week_data: "6.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-06-15",
                  week_data: "5.1%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-06-22",
                  week_data: "14.1%",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-06-29",
                  week_data: "-4.7%",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-07-06",
                  week_data: "0.7%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-07-13",
                  week_data: "-3.0%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-07-20",
                  week_data: "2.5%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-07-27",
                  week_data: "-4.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "7.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-08-03",
                  week_data: "3.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-08-10",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-08-17",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-08-24",
                  week_data: "2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-08-31",
                  week_data: "-1.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-09-07",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-09-14",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-09-21",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-09-28",
                  week_data: "1.0%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-10-05",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-10-12",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-10-19",
                  week_data: "-0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-10-26",
                  week_data: "1.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-11-02",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-11-09",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-11-16",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-11-23",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2020-11-30",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2020-12-07",
                  week_data: "-1.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2020-12-14",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2020-12-21",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2020-12-28",
                  week_data: "2.4%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "68.25%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-6.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-01-04",
                  week_data: "3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-01-11",
                  week_data: "-2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-01-18",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-01-25",
                  week_data: "-6.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "16.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-02-01",
                  week_data: "9.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-02-08",
                  week_data: "5.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-02-15",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-02-22",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "10.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-03-01",
                  week_data: "2.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-03-08",
                  week_data: "0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-03-15",
                  week_data: "-0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-03-22",
                  week_data: "1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-03-29",
                  week_data: "5.8%",
                  regime: "011",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "9.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-04-05",
                  week_data: "5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-04-12",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-04-19",
                  week_data: "1.2%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-04-26",
                  week_data: "3.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "11.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-05-03",
                  week_data: "6.7%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-05-10",
                  week_data: "-6.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-05-17",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-05-24",
                  week_data: "-0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-05-31",
                  week_data: "8.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-06-07",
                  week_data: "1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-06-14",
                  week_data: "-5.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-06-21",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-06-28",
                  week_data: "-0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-07-05",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-07-12",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-07-19",
                  week_data: "-0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-07-26",
                  week_data: "2.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-08-02",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-08-09",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-08-16",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-08-23",
                  week_data: "3.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-08-30",
                  week_data: "5.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-09-06",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-09-13",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-09-20",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-09-27",
                  week_data: "0.2%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-10-04",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-10-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-10-18",
                  week_data: "-4.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-10-25",
                  week_data: "-4.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-11-01",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-11-08",
                  week_data: "6.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-11-15",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-11-22",
                  week_data: "-4.5%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2021-11-29",
                  week_data: "1.3%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2021-12-06",
                  week_data: "0.2%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2021-12-13",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2021-12-20",
                  week_data: "-0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2021-12-27",
                  week_data: "2.6%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "13.82%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-01-03",
                  week_data: "1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-01-10",
                  week_data: "3.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-01-17",
                  week_data: "-3.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-01-24",
                  week_data: "-4.8%",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-01-31",
                  week_data: "1.6%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-02-07",
                  week_data: "-0.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-02-14",
                  week_data: "-2.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-02-21",
                  week_data: "-2.2%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-02-28",
                  week_data: "1.1%",
                  regime: "001",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-03-07",
                  week_data: "2.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-03-14",
                  week_data: "0.1%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-03-21",
                  week_data: "-2.2%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-03-28",
                  week_data: "2.2%",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-04-04",
                  week_data: "0.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-04-11",
                  week_data: "-2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-04-18",
                  week_data: "-1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-04-25",
                  week_data: "-3.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-05-02",
                  week_data: "-4.6%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-05-09",
                  week_data: "-6.4%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-05-16",
                  week_data: "4.3%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-05-23",
                  week_data: "-2.5%",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-05-30",
                  week_data: "3.8%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-06-06",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-06-13",
                  week_data: "-7.1%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-06-20",
                  week_data: "2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-06-27",
                  week_data: "2.2%",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "13.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-07-04",
                  week_data: "3.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-07-11",
                  week_data: "4.5%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-07-18",
                  week_data: "3.0%",
                  regime: "100",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-07-25",
                  week_data: "2.0%",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "14.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-08-01",
                  week_data: "4.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-08-08",
                  week_data: "3.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-08-15",
                  week_data: "1.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-08-22",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-08-29",
                  week_data: "2.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-09-05",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-09-12",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-09-19",
                  week_data: "0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-09-26",
                  week_data: "-0.5%",
                  regime: "011",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-10-03",
                  week_data: "1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-10-10",
                  week_data: "-1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-10-17",
                  week_data: "0.6%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-10-24",
                  week_data: "1.7%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2022-10-31",
                  week_data: "4.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-11-07",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-11-14",
                  week_data: "-2.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-11-21",
                  week_data: "-1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-11-28",
                  week_data: "1.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2022-12-05",
                  week_data: "1.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2022-12-12",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2022-12-19",
                  week_data: "-8.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2022-12-26",
                  week_data: "7.7%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "32.06%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-16.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-01-02",
                  week_data: "-2.1%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-01-09",
                  week_data: "-1.7%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-01-16",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-01-23",
                  week_data: "-8.3%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-01-30",
                  week_data: "-1.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-02-06",
                  week_data: "0.2%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-02-13",
                  week_data: "-0.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-02-20",
                  week_data: "-1.3%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-02-27",
                  week_data: "1.4%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-03-06",
                  week_data: "-1.3%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-03-13",
                  week_data: "-2.9%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-03-20",
                  week_data: "-0.6%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-03-27",
                  week_data: "0.0%",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-04-03",
                  week_data: "5.6%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-04-10",
                  week_data: "2.2%",
                  regime: "100",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-04-17",
                  week_data: "1.2%",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-04-24",
                  week_data: "2.6%",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-05-01",
                  week_data: "1.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-05-08",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-05-15",
                  week_data: "-1.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-05-22",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-05-29",
                  week_data: "1.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-06-05",
                  week_data: "-0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-06-12",
                  week_data: "2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-06-19",
                  week_data: "-2.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-06-26",
                  week_data: "3.9%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-07-03",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-07-10",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-07-17",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-07-24",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-07-31",
                  week_data: "-0.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-08-07",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-08-14",
                  week_data: "1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-08-21",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-08-28",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-09-04",
                  week_data: "5.2%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-09-11",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-09-18",
                  week_data: "0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-09-25",
                  week_data: "4.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-10-02",
                  week_data: "-1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-10-09",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-10-16",
                  week_data: "-2.0%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-10-23",
                  week_data: "-1.4%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2023-10-30",
                  week_data: "2.9%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "14.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-11-06",
                  week_data: "4.0%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-11-13",
                  week_data: "5.2%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-11-20",
                  week_data: "-0.6%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-11-27",
                  week_data: "5.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2023-12-04",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2023-12-11",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2023-12-18",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2023-12-25",
                  week_data: "1.8%",
                  regime: "111",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "20.16%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "4.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-01-01",
                  week_data: "4.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-01-08",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-01-15",
                  week_data: "0.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-01-22",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-01-29",
                  week_data: "2.5%",
                  regime: "111",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-02-05",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-02-12",
                  week_data: "0.4%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-02-19",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-02-26",
                  week_data: "0.7%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-03-04",
                  week_data: "2.3%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-03-11",
                  week_data: "-7.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-03-18",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-03-25",
                  week_data: "2.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-04-01",
                  week_data: "4.4%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-04-08",
                  week_data: "-1.8%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-04-15",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-04-22",
                  week_data: "6.2%",
                  regime: "011",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-04-29",
                  week_data: "1.1%",
                  regime: "111",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-05-06",
                  week_data: "-4.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-05-13",
                  week_data: "8.8%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-05-20",
                  week_data: "2.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-05-27",
                  week_data: "-2.4%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-06-03",
                  week_data: "-1.9%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-06-10",
                  week_data: "7.2%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-06-17",
                  week_data: "-1.4%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-06-24",
                  week_data: "0.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-07-01",
                  week_data: "3.1%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-07-08",
                  week_data: "2.7%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-07-15",
                  week_data: "-6.8%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-07-22",
                  week_data: "1.6%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-07-29",
                  week_data: "-0.3%",
                  regime: "111",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-08-05",
                  week_data: "0.8%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-08-12",
                  week_data: "2.5%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-08-19",
                  week_data: "0.5%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-08-26",
                  week_data: "2.0%",
                  regime: "111",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-09-02",
                  week_data: "-3.5%",
                  regime: "111",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-09-09",
                  week_data: "0.0%",
                  regime: "111",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-09-16",
                  week_data: "-0.3%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-09-23",
                  week_data: "3.0%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-09-30",
                  week_data: "-4.8%",
                  regime: "111",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-10-07",
                  week_data: "3.9%",
                  regime: "011",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-10-14",
                  week_data: "-2.6%",
                  regime: "011",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-10-21",
                  week_data: "-7.7%",
                  regime: "011",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-10-28",
                  week_data: "-0.2%",
                  regime: "001",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-11-04",
                  week_data: "2.1%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-11-11",
                  week_data: "-3.0%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-11-18",
                  week_data: "2.5%",
                  regime: "001",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-11-25",
                  week_data: "1.0%",
                  regime: "001",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2024-12-30",
                  week_data: "1.5%",
                  regime: "001",
                },
                {
                  weekNum: "W2",
                  week_date: "2024-12-02",
                  week_data: "3.5%",
                  regime: "001",
                },
                {
                  weekNum: "W3",
                  week_date: "2024-12-09",
                  week_data: "0.2%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2024-12-16",
                  week_data: "-1.7%",
                  regime: "111",
                },
                {
                  weekNum: "W5",
                  week_date: "2024-12-23",
                  week_data: "0.1%",
                  regime: "001",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "6.18%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-01-06",
                  week_data: "-6.5%",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-01-13",
                  week_data: "6.2%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-01-20",
                  week_data: "-4.1%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-01-27",
                  week_data: "3.6%",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-14.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-02-03",
                  week_data: "-0.7%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-02-10",
                  week_data: "-8.6%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-02-17",
                  week_data: "0.8%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-02-24",
                  week_data: "-6.9%",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "4.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-03-03",
                  week_data: "3.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-03-10",
                  week_data: "-2.7%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-03-17",
                  week_data: "8.7%",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-03-24",
                  week_data: "0.1%",
                  regime: "100",
                },
                {
                  weekNum: "W5",
                  week_date: "2025-03-31",
                  week_data: "-4.5%",
                  regime: "100",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "10.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-04-07",
                  week_data: "1.1%",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-04-14",
                  week_data: "4.8%",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-04-21",
                  week_data: "2.9%",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-04-28",
                  week_data: "1.5%",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-05-05",
                  week_data: "-3.1%",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_date: "2025-05-12",
                  week_data: "7.1%",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_date: "2025-05-19",
                  week_data: "-0.1%",
                  regime: "111",
                },
                {
                  weekNum: "W4",
                  week_date: "2025-05-26",
                  week_data: "2.6%",
                  regime: "111",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "3.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_date: "2025-06-02",
                  week_data: "3.1%",
                  regime: "111",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      strategy: "Custom strategy",
      ytds: [
        {
          year: 2011,
          ytd_data: "-15.85%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-5.7%",
                  week_date: "2011-01-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-2.5%",
                  week_date: "2011-01-10",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "3.6%",
                  week_date: "2011-01-17",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-4.1%",
                  week_date: "2011-01-24",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2011-01-31",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2011-02-07",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2011-02-14",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2011-02-21",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2011-02-28",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2011-03-07",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2011-03-14",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2011-03-21",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "6.2%",
                  week_date: "2011-03-28",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "4.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.5%",
                  week_date: "2011-04-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.7%",
                  week_date: "2011-04-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.3%",
                  week_date: "2011-04-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.8%",
                  week_date: "2011-04-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-4.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-4.8%",
                  week_date: "2011-05-02",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2011-05-09",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2011-05-16",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2011-05-23",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2011-05-30",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2011-06-06",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2011-06-13",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2011-06-20",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2011-06-27",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2011-07-04",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2011-07-11",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2011-07-18",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2011-07-25",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2011-08-01",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2011-08-08",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2011-08-15",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2011-08-22",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2011-08-29",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2011-09-05",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2011-09-12",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2011-09-19",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2011-09-26",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2011-10-03",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2011-10-10",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "-4.2%",
                  week_date: "2011-10-17",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "5.7%",
                  week_date: "2011-10-24",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2011-10-31",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-13.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2011-11-07",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_data: "-13.8%",
                  week_date: "2011-11-14",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2011-11-21",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2011-11-28",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2011-12-05",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2011-12-12",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2011-12-19",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2011-12-26",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2012,
          ytd_data: "38.61%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2012-01-02",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2012-01-09",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "7.7%",
                  week_date: "2012-01-16",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2012-01-23",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2012-01-30",
                  regime: "110",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-0.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "3.5%",
                  week_date: "2012-02-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "4.3%",
                  week_date: "2012-02-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-7.4%",
                  week_date: "2012-02-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.3%",
                  week_date: "2012-02-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.8%",
                  week_date: "2012-03-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.7%",
                  week_date: "2012-03-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.3%",
                  week_date: "2012-03-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.2%",
                  week_date: "2012-03-26",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.2%",
                  week_date: "2012-04-02",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.9%",
                  week_date: "2012-04-09",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "3.4%",
                  week_date: "2012-04-16",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-3.2%",
                  week_date: "2012-04-23",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2012-04-30",
                  regime: "010",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2012-05-07",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2012-05-14",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2012-05-21",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2012-05-28",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2012-06-04",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2012-06-11",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.7%",
                  week_date: "2012-06-18",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2012-06-25",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.0%",
                  week_date: "2012-07-02",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.1%",
                  week_date: "2012-07-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.9%",
                  week_date: "2012-07-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.9%",
                  week_date: "2012-07-23",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2012-07-30",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.4%",
                  week_date: "2012-08-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.1%",
                  week_date: "2012-08-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.2%",
                  week_date: "2012-08-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.5%",
                  week_date: "2012-08-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "5.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.9%",
                  week_date: "2012-09-03",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-2.1%",
                  week_date: "2012-09-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.7%",
                  week_date: "2012-09-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "3.8%",
                  week_date: "2012-09-24",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.1%",
                  week_date: "2012-10-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.8%",
                  week_date: "2012-10-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.1%",
                  week_date: "2012-10-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.1%",
                  week_date: "2012-10-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.2%",
                  week_date: "2012-10-29",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "3.0%",
                  week_date: "2012-11-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.2%",
                  week_date: "2012-11-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.4%",
                  week_date: "2012-11-19",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "3.5%",
                  week_date: "2012-11-26",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "4.5%",
                  week_date: "2012-12-31",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "4.6%",
                  week_date: "2012-12-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.1%",
                  week_date: "2012-12-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.3%",
                  week_date: "2012-12-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.4%",
                  week_date: "2012-12-24",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2013,
          ytd_data: "-3.70%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-9.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-3.3%",
                  week_date: "2013-01-07",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-2.8%",
                  week_date: "2013-01-14",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-2.7%",
                  week_date: "2013-01-21",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.7%",
                  week_date: "2013-01-28",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-1.9%",
                  week_date: "2013-02-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.3%",
                  week_date: "2013-02-11",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.7%",
                  week_date: "2013-02-18",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-4.1%",
                  week_date: "2013-02-25",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.5%",
                  week_date: "2013-03-04",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.8%",
                  week_date: "2013-03-11",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-6.8%",
                  week_date: "2013-03-18",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.6%",
                  week_date: "2013-03-25",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-2.6%",
                  week_date: "2013-04-01",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2013-04-08",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2013-04-15",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2013-04-22",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2013-04-29",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.7%",
                  week_date: "2013-05-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.8%",
                  week_date: "2013-05-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.8%",
                  week_date: "2013-05-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.4%",
                  week_date: "2013-05-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.1%",
                  week_date: "2013-06-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-2.2%",
                  week_date: "2013-06-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.0%",
                  week_date: "2013-06-17",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2013-06-24",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "3.3%",
                  week_date: "2013-07-01",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "4.3%",
                  week_date: "2013-07-08",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.9%",
                  week_date: "2013-07-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.7%",
                  week_date: "2013-07-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2013-07-29",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2013-08-05",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2013-08-12",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2013-08-19",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2013-08-26",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2013-09-02",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2013-09-09",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.3%",
                  week_date: "2013-09-16",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.0%",
                  week_date: "2013-09-23",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "2.1%",
                  week_date: "2013-09-30",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2013-10-07",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.7%",
                  week_date: "2013-10-14",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.1%",
                  week_date: "2013-10-21",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.7%",
                  week_date: "2013-10-28",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.0%",
                  week_date: "2013-11-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.9%",
                  week_date: "2013-11-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.4%",
                  week_date: "2013-11-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.8%",
                  week_date: "2013-11-25",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "10.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.5%",
                  week_date: "2013-12-30",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.7%",
                  week_date: "2013-12-02",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.2%",
                  week_date: "2013-12-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "6.2%",
                  week_date: "2013-12-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "2.4%",
                  week_date: "2013-12-23",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2014,
          ytd_data: "69.68%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.9%",
                  week_date: "2014-01-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.5%",
                  week_date: "2014-01-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.6%",
                  week_date: "2014-01-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.7%",
                  week_date: "2014-01-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.0%",
                  week_date: "2014-02-03",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.1%",
                  week_date: "2014-02-10",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "3.6%",
                  week_date: "2014-02-17",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.0%",
                  week_date: "2014-02-24",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.1%",
                  week_date: "2014-03-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.9%",
                  week_date: "2014-03-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "2.8%",
                  week_date: "2014-03-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.5%",
                  week_date: "2014-03-24",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "2.4%",
                  week_date: "2014-03-31",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "4.0%",
                  week_date: "2014-04-07",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.5%",
                  week_date: "2014-04-14",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.1%",
                  week_date: "2014-04-21",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.7%",
                  week_date: "2014-04-28",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "12.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.9%",
                  week_date: "2014-05-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "5.7%",
                  week_date: "2014-05-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "6.8%",
                  week_date: "2014-05-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.9%",
                  week_date: "2014-05-26",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "14.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "9.8%",
                  week_date: "2014-06-02",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.4%",
                  week_date: "2014-06-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.8%",
                  week_date: "2014-06-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.1%",
                  week_date: "2014-06-23",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "5.4%",
                  week_date: "2014-06-30",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-10.2%",
                  week_date: "2014-07-07",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "6.4%",
                  week_date: "2014-07-14",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.5%",
                  week_date: "2014-07-21",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.2%",
                  week_date: "2014-07-28",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.0%",
                  week_date: "2014-08-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.2%",
                  week_date: "2014-08-11",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.5%",
                  week_date: "2014-08-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.4%",
                  week_date: "2014-08-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "7.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "7.5%",
                  week_date: "2014-09-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "4.3%",
                  week_date: "2014-09-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.8%",
                  week_date: "2014-09-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-3.9%",
                  week_date: "2014-09-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.4%",
                  week_date: "2014-09-29",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "2.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-3.1%",
                  week_date: "2014-10-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.6%",
                  week_date: "2014-10-13",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "3.5%",
                  week_date: "2014-10-20",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.7%",
                  week_date: "2014-10-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.1%",
                  week_date: "2014-11-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "3.0%",
                  week_date: "2014-11-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.0%",
                  week_date: "2014-11-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.8%",
                  week_date: "2014-11-24",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.7%",
                  week_date: "2014-12-29",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "3.9%",
                  week_date: "2014-12-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-3.5%",
                  week_date: "2014-12-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.1%",
                  week_date: "2014-12-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.5%",
                  week_date: "2014-12-22",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2015,
          ytd_data: "2.17%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.5%",
                  week_date: "2015-01-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.8%",
                  week_date: "2015-01-12",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.8%",
                  week_date: "2015-01-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.6%",
                  week_date: "2015-01-26",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-3.3%",
                  week_date: "2015-02-02",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "7.5%",
                  week_date: "2015-02-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.2%",
                  week_date: "2015-02-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.6%",
                  week_date: "2015-02-23",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.9%",
                  week_date: "2015-03-02",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.7%",
                  week_date: "2015-03-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.3%",
                  week_date: "2015-03-16",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.8%",
                  week_date: "2015-03-23",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "4.2%",
                  week_date: "2015-03-30",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-14.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.4%",
                  week_date: "2015-04-06",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-6.2%",
                  week_date: "2015-04-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-6.8%",
                  week_date: "2015-04-20",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.1%",
                  week_date: "2015-04-27",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.9%",
                  week_date: "2015-05-04",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "3.3%",
                  week_date: "2015-05-11",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "2.2%",
                  week_date: "2015-05-18",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2015-05-25",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2015-06-01",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2015-06-08",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2015-06-15",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.4%",
                  week_date: "2015-06-22",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2015-06-29",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "0.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.9%",
                  week_date: "2015-07-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2015-07-13",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_data: "-2.0%",
                  week_date: "2015-07-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.3%",
                  week_date: "2015-07-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.9%",
                  week_date: "2015-08-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.1%",
                  week_date: "2015-08-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.0%",
                  week_date: "2015-08-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-5.2%",
                  week_date: "2015-08-24",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2015-08-31",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2015-09-07",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2015-09-14",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2015-09-21",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2015-09-28",
                  regime: "000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2015-10-05",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "6.6%",
                  week_date: "2015-10-12",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2015-10-19",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2015-10-26",
                  regime: "110",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-6.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-6.9%",
                  week_date: "2015-11-02",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2015-11-09",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2015-11-16",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2015-11-23",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2015-11-30",
                  regime: "000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2015-12-07",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2015-12-14",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2015-12-21",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.9%",
                  week_date: "2015-12-28",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2016,
          ytd_data: "5.13%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2016-01-04",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2016-01-11",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2016-01-18",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2016-01-25",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2016-02-01",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2016-02-08",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2016-02-15",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2016-02-22",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2016-02-29",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.4%",
                  week_date: "2016-03-07",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.2%",
                  week_date: "2016-03-14",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "3.4%",
                  week_date: "2016-03-21",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2016-03-28",
                  regime: "110",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2016-04-04",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_data: "3.9%",
                  week_date: "2016-04-11",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2016-04-18",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2016-04-25",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2016-05-02",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2016-05-09",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2016-05-16",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2016-05-23",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_data: "-0.1%",
                  week_date: "2016-05-30",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.4%",
                  week_date: "2016-06-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.7%",
                  week_date: "2016-06-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.4%",
                  week_date: "2016-06-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "6.5%",
                  week_date: "2016-06-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.6%",
                  week_date: "2016-07-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.4%",
                  week_date: "2016-07-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.4%",
                  week_date: "2016-07-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.1%",
                  week_date: "2016-07-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.8%",
                  week_date: "2016-08-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.5%",
                  week_date: "2016-08-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "5.9%",
                  week_date: "2016-08-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.7%",
                  week_date: "2016-08-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "1.1%",
                  week_date: "2016-08-29",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-4.3%",
                  week_date: "2016-09-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-3.5%",
                  week_date: "2016-09-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "4.1%",
                  week_date: "2016-09-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.6%",
                  week_date: "2016-09-26",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.4%",
                  week_date: "2016-10-03",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.6%",
                  week_date: "2016-10-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.7%",
                  week_date: "2016-10-17",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.9%",
                  week_date: "2016-10-24",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "-6.2%",
                  week_date: "2016-10-31",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.8%",
                  week_date: "2016-11-07",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-2.9%",
                  week_date: "2016-11-14",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.4%",
                  week_date: "2016-11-21",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.2%",
                  week_date: "2016-11-28",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "4.0%",
                  week_date: "2016-12-05",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-4.7%",
                  week_date: "2016-12-12",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-5.0%",
                  week_date: "2016-12-19",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2016-12-26",
                  regime: "000",
                },
              ],
            },
          ],
        },
        {
          year: 2017,
          ytd_data: "25.17%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "3.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "4.3%",
                  week_date: "2017-01-02",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2017-01-09",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2017-01-16",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2017-01-23",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_data: "-0.6%",
                  week_date: "2017-01-30",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-2.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.2%",
                  week_date: "2017-02-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-2.1%",
                  week_date: "2017-02-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.0%",
                  week_date: "2017-02-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.9%",
                  week_date: "2017-02-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-2.5%",
                  week_date: "2017-03-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.1%",
                  week_date: "2017-03-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.3%",
                  week_date: "2017-03-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.3%",
                  week_date: "2017-03-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "2.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.8%",
                  week_date: "2017-04-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.1%",
                  week_date: "2017-04-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "3.5%",
                  week_date: "2017-04-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-3.3%",
                  week_date: "2017-04-24",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-1.2%",
                  week_date: "2017-05-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.0%",
                  week_date: "2017-05-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-3.4%",
                  week_date: "2017-05-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.7%",
                  week_date: "2017-05-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "1.4%",
                  week_date: "2017-05-29",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.6%",
                  week_date: "2017-06-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.9%",
                  week_date: "2017-06-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-4.4%",
                  week_date: "2017-06-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.2%",
                  week_date: "2017-06-26",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "7.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.8%",
                  week_date: "2017-07-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.4%",
                  week_date: "2017-07-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.3%",
                  week_date: "2017-07-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.5%",
                  week_date: "2017-07-24",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.8%",
                  week_date: "2017-07-31",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "3.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-5.6%",
                  week_date: "2017-08-07",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "6.0%",
                  week_date: "2017-08-14",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.3%",
                  week_date: "2017-08-21",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "5.1%",
                  week_date: "2017-08-28",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.8%",
                  week_date: "2017-09-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.3%",
                  week_date: "2017-09-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-2.3%",
                  week_date: "2017-09-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.2%",
                  week_date: "2017-09-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.8%",
                  week_date: "2017-10-02",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "3.0%",
                  week_date: "2017-10-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.6%",
                  week_date: "2017-10-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.3%",
                  week_date: "2017-10-23",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "2.2%",
                  week_date: "2017-10-30",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-1.8%",
                  week_date: "2017-11-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.1%",
                  week_date: "2017-11-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "5.2%",
                  week_date: "2017-11-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.3%",
                  week_date: "2017-11-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.4%",
                  week_date: "2017-12-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.3%",
                  week_date: "2017-12-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "3.5%",
                  week_date: "2017-12-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.9%",
                  week_date: "2017-12-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2018,
          ytd_data: "-12.05%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-13.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-1.3%",
                  week_date: "2018-01-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.6%",
                  week_date: "2018-01-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.6%",
                  week_date: "2018-01-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.5%",
                  week_date: "2018-01-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "-13.5%",
                  week_date: "2018-01-29",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "3.2%",
                  week_date: "2018-02-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.6%",
                  week_date: "2018-02-12",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.1%",
                  week_date: "2018-02-19",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.1%",
                  week_date: "2018-02-26",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-5.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-3.7%",
                  week_date: "2018-03-05",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.1%",
                  week_date: "2018-03-12",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.7%",
                  week_date: "2018-03-19",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2018-03-26",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.5%",
                  week_date: "2018-04-02",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2018-04-09",
                  regime: "101",
                },
                {
                  weekNum: "W3",
                  week_data: "2.0%",
                  week_date: "2018-04-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "4.9%",
                  week_date: "2018-04-23",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "-3.1%",
                  week_date: "2018-04-30",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-0.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.6%",
                  week_date: "2018-05-07",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.1%",
                  week_date: "2018-05-14",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2018-05-21",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2018-05-28",
                  regime: "101",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-1.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.2%",
                  week_date: "2018-06-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.8%",
                  week_date: "2018-06-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.9%",
                  week_date: "2018-06-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.2%",
                  week_date: "2018-06-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.3%",
                  week_date: "2018-07-02",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "3.8%",
                  week_date: "2018-07-09",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.2%",
                  week_date: "2018-07-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.8%",
                  week_date: "2018-07-23",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.3%",
                  week_date: "2018-07-30",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "6.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.9%",
                  week_date: "2018-08-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.7%",
                  week_date: "2018-08-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "2.0%",
                  week_date: "2018-08-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.7%",
                  week_date: "2018-08-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-7.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-2.6%",
                  week_date: "2018-09-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.9%",
                  week_date: "2018-09-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.6%",
                  week_date: "2018-09-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.2%",
                  week_date: "2018-09-24",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2018-10-01",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2018-10-08",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2018-10-15",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2018-10-22",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2018-10-29",
                  regime: "000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2018-11-05",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2018-11-12",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.5%",
                  week_date: "2018-11-19",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.9%",
                  week_date: "2018-11-26",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "2.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-1.2%",
                  week_date: "2018-12-31",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-4.4%",
                  week_date: "2018-12-03",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "7.0%",
                  week_date: "2018-12-10",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.5%",
                  week_date: "2018-12-17",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "-0.4%",
                  week_date: "2018-12-24",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2019,
          ytd_data: "9.24%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-1.3%",
                  week_date: "2019-01-07",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2019-01-14",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2019-01-21",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2019-01-28",
                  regime: "010",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2019-02-04",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2019-02-11",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2019-02-18",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2019-02-25",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "5.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2019-03-04",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_data: "2.5%",
                  week_date: "2019-03-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.5%",
                  week_date: "2019-03-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.8%",
                  week_date: "2019-03-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "-3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.5%",
                  week_date: "2019-04-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.5%",
                  week_date: "2019-04-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.5%",
                  week_date: "2019-04-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.6%",
                  week_date: "2019-04-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "-1.3%",
                  week_date: "2019-04-29",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-2.5%",
                  week_date: "2019-05-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "3.8%",
                  week_date: "2019-05-13",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "4.4%",
                  week_date: "2019-05-20",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.7%",
                  week_date: "2019-05-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.3%",
                  week_date: "2019-06-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.9%",
                  week_date: "2019-06-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.9%",
                  week_date: "2019-06-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.2%",
                  week_date: "2019-06-24",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-7.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-1.0%",
                  week_date: "2019-07-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-6.4%",
                  week_date: "2019-07-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.8%",
                  week_date: "2019-07-15",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.6%",
                  week_date: "2019-07-22",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2019-07-29",
                  regime: "000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2019-08-05",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2019-08-12",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2019-08-19",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2019-08-26",
                  regime: "000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2019-09-02",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2019-09-09",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2019-09-16",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2019-09-23",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_data: "-2.7%",
                  week_date: "2019-09-30",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "12.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-3.3%",
                  week_date: "2019-10-07",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "13.9%",
                  week_date: "2019-10-14",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.1%",
                  week_date: "2019-10-21",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.8%",
                  week_date: "2019-10-28",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "0.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-2.5%",
                  week_date: "2019-11-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "3.0%",
                  week_date: "2019-11-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.0%",
                  week_date: "2019-11-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.7%",
                  week_date: "2019-11-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "0.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.2%",
                  week_date: "2019-12-30",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-3.1%",
                  week_date: "2019-12-02",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.4%",
                  week_date: "2019-12-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.6%",
                  week_date: "2019-12-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.1%",
                  week_date: "2019-12-23",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2020,
          ytd_data: "55.52%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.5%",
                  week_date: "2020-01-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "3.6%",
                  week_date: "2020-01-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.2%",
                  week_date: "2020-01-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-4.1%",
                  week_date: "2020-01-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-3.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "5.3%",
                  week_date: "2020-02-03",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.4%",
                  week_date: "2020-02-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.5%",
                  week_date: "2020-02-17",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-7.2%",
                  week_date: "2020-02-24",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2020-03-02",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2020-03-09",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2020-03-16",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2020-03-23",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2020-03-30",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2020-04-06",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2020-04-13",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2020-04-20",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2020-04-27",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "-5.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-8.4%",
                  week_date: "2020-05-04",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2020-05-11",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "-3.1%",
                  week_date: "2020-05-18",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "6.3%",
                  week_date: "2020-05-25",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "19.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "19.5%",
                  week_date: "2020-06-01",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2020-06-08",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2020-06-15",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2020-06-22",
                  regime: "110",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2020-06-29",
                  regime: "110",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2020-07-06",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2020-07-13",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2020-07-20",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_data: "3.0%",
                  week_date: "2020-07-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "2.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.1%",
                  week_date: "2020-08-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.9%",
                  week_date: "2020-08-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.4%",
                  week_date: "2020-08-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.6%",
                  week_date: "2020-08-24",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.1%",
                  week_date: "2020-08-31",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "2.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.2%",
                  week_date: "2020-09-07",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.5%",
                  week_date: "2020-09-14",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-5.0%",
                  week_date: "2020-09-21",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "5.1%",
                  week_date: "2020-09-28",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.5%",
                  week_date: "2020-10-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.3%",
                  week_date: "2020-10-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.0%",
                  week_date: "2020-10-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.9%",
                  week_date: "2020-10-26",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "26.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "4.2%",
                  week_date: "2020-11-02",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "4.8%",
                  week_date: "2020-11-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "5.3%",
                  week_date: "2020-11-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "6.4%",
                  week_date: "2020-11-23",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "3.5%",
                  week_date: "2020-11-30",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "6.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.6%",
                  week_date: "2020-12-07",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.3%",
                  week_date: "2020-12-14",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.6%",
                  week_date: "2020-12-21",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.8%",
                  week_date: "2020-12-28",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2021,
          ytd_data: "74.58%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "1.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "7.5%",
                  week_date: "2021-01-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-2.7%",
                  week_date: "2021-01-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.8%",
                  week_date: "2021-01-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.4%",
                  week_date: "2021-01-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "23.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "11.1%",
                  week_date: "2021-02-01",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "4.5%",
                  week_date: "2021-02-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "4.3%",
                  week_date: "2021-02-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.9%",
                  week_date: "2021-02-22",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "11.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "7.4%",
                  week_date: "2021-03-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.2%",
                  week_date: "2021-03-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.6%",
                  week_date: "2021-03-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.5%",
                  week_date: "2021-03-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "5.0%",
                  week_date: "2021-03-29",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "12.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "4.8%",
                  week_date: "2021-04-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-2.4%",
                  week_date: "2021-04-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "2.9%",
                  week_date: "2021-04-19",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "7.3%",
                  week_date: "2021-04-26",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "14.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "9.9%",
                  week_date: "2021-05-03",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-6.8%",
                  week_date: "2021-05-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "4.5%",
                  week_date: "2021-05-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.6%",
                  week_date: "2021-05-24",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "8.0%",
                  week_date: "2021-05-31",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "-10.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.0%",
                  week_date: "2021-06-07",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-9.4%",
                  week_date: "2021-06-14",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.1%",
                  week_date: "2021-06-21",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.5%",
                  week_date: "2021-06-28",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "4.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.5%",
                  week_date: "2021-07-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.1%",
                  week_date: "2021-07-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.6%",
                  week_date: "2021-07-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.3%",
                  week_date: "2021-07-26",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "1.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.0%",
                  week_date: "2021-08-02",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.4%",
                  week_date: "2021-08-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-3.6%",
                  week_date: "2021-08-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.2%",
                  week_date: "2021-08-23",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "3.5%",
                  week_date: "2021-08-30",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "3.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.6%",
                  week_date: "2021-09-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "3.1%",
                  week_date: "2021-09-13",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.3%",
                  week_date: "2021-09-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.1%",
                  week_date: "2021-09-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-2.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "5.1%",
                  week_date: "2021-10-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.3%",
                  week_date: "2021-10-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-5.9%",
                  week_date: "2021-10-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-3.7%",
                  week_date: "2021-10-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "-1.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.3%",
                  week_date: "2021-11-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.9%",
                  week_date: "2021-11-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.6%",
                  week_date: "2021-11-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-6.5%",
                  week_date: "2021-11-22",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "2.4%",
                  week_date: "2021-11-29",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "1.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-1.1%",
                  week_date: "2021-12-06",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.6%",
                  week_date: "2021-12-13",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.2%",
                  week_date: "2021-12-20",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "3.0%",
                  week_date: "2021-12-27",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2022,
          ytd_data: "28.52%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.2%",
                  week_date: "2022-01-03",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.3%",
                  week_date: "2022-01-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-5.0%",
                  week_date: "2022-01-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2022-01-24",
                  regime: "101",
                },
                {
                  weekNum: "W5",
                  week_data: "2.5%",
                  week_date: "2022-01-31",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-6.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2022-02-07",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.0%",
                  week_date: "2022-02-14",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-3.6%",
                  week_date: "2022-02-21",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.6%",
                  week_date: "2022-02-28",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2022-03-07",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.2%",
                  week_date: "2022-03-14",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2022-03-21",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2022-03-28",
                  regime: "101",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "5.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "3.9%",
                  week_date: "2022-04-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.0%",
                  week_date: "2022-04-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.9%",
                  week_date: "2022-04-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.7%",
                  week_date: "2022-04-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2022-05-02",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2022-05-09",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2022-05-16",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2022-05-23",
                  regime: "000",
                },
                {
                  weekNum: "W5",
                  week_data: "0.00%",
                  week_date: "2022-05-30",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2022-06-06",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2022-06-13",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2022-06-20",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2022-06-27",
                  regime: "000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2022-07-04",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.1%",
                  week_date: "2022-07-11",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "7.5%",
                  week_date: "2022-07-18",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2022-07-25",
                  regime: "110",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "13.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "5.3%",
                  week_date: "2022-08-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.9%",
                  week_date: "2022-08-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.1%",
                  week_date: "2022-08-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.4%",
                  week_date: "2022-08-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "3.4%",
                  week_date: "2022-08-29",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-0.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.2%",
                  week_date: "2022-09-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.2%",
                  week_date: "2022-09-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.4%",
                  week_date: "2022-09-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-4.6%",
                  week_date: "2022-09-26",
                  regime: "011",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "4.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.0%",
                  week_date: "2022-10-03",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-3.8%",
                  week_date: "2022-10-10",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "2.6%",
                  week_date: "2022-10-17",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.5%",
                  week_date: "2022-10-24",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "4.1%",
                  week_date: "2022-10-31",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.6%",
                  week_date: "2022-11-07",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.1%",
                  week_date: "2022-11-14",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.7%",
                  week_date: "2022-11-21",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "3.3%",
                  week_date: "2022-11-28",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "-0.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.7%",
                  week_date: "2022-12-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.4%",
                  week_date: "2022-12-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-9.7%",
                  week_date: "2022-12-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "9.4%",
                  week_date: "2022-12-26",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2023,
          ytd_data: "51.12%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "-5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.8%",
                  week_date: "2023-01-02",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.1%",
                  week_date: "2023-01-09",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.3%",
                  week_date: "2023-01-16",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-6.3%",
                  week_date: "2023-01-23",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "1.5%",
                  week_date: "2023-01-30",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "-6.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.3%",
                  week_date: "2023-02-06",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.8%",
                  week_date: "2023-02-13",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-4.3%",
                  week_date: "2023-02-20",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2023-02-27",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2023-03-06",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2023-03-13",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2023-03-20",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2023-03-27",
                  regime: "000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "1.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2023-04-03",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.7%",
                  week_date: "2023-04-10",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2023-04-17",
                  regime: "101",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2023-04-24",
                  regime: "101",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.4%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-0.1%",
                  week_date: "2023-05-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.1%",
                  week_date: "2023-05-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.3%",
                  week_date: "2023-05-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.4%",
                  week_date: "2023-05-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "1.7%",
                  week_date: "2023-05-29",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.4%",
                  week_date: "2023-06-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.4%",
                  week_date: "2023-06-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-2.2%",
                  week_date: "2023-06-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "4.9%",
                  week_date: "2023-06-26",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "8.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.6%",
                  week_date: "2023-07-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.1%",
                  week_date: "2023-07-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "3.4%",
                  week_date: "2023-07-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.5%",
                  week_date: "2023-07-24",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "-1.0%",
                  week_date: "2023-07-31",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "5.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.6%",
                  week_date: "2023-08-07",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.9%",
                  week_date: "2023-08-14",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.6%",
                  week_date: "2023-08-21",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "3.3%",
                  week_date: "2023-08-28",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "6.8%",
                  week_date: "2023-09-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-1.9%",
                  week_date: "2023-09-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.0%",
                  week_date: "2023-09-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "4.7%",
                  week_date: "2023-09-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-1.5%",
                  week_date: "2023-10-02",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.5%",
                  week_date: "2023-10-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.5%",
                  week_date: "2023-10-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-1.6%",
                  week_date: "2023-10-23",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "2.0%",
                  week_date: "2023-10-30",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "19.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "5.8%",
                  week_date: "2023-11-06",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "4.4%",
                  week_date: "2023-11-13",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.1%",
                  week_date: "2023-11-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "8.1%",
                  week_date: "2023-11-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "4.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "3.0%",
                  week_date: "2023-12-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "1.5%",
                  week_date: "2023-12-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.7%",
                  week_date: "2023-12-18",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.9%",
                  week_date: "2023-12-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2024,
          ytd_data: "46.00%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "8.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "4.5%",
                  week_date: "2024-01-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-0.7%",
                  week_date: "2024-01-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "1.4%",
                  week_date: "2024-01-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.0%",
                  week_date: "2024-01-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "5.0%",
                  week_date: "2024-01-29",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "1.2%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.1%",
                  week_date: "2024-02-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "3.0%",
                  week_date: "2024-02-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-1.3%",
                  week_date: "2024-02-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.6%",
                  week_date: "2024-02-26",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "0.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.2%",
                  week_date: "2024-03-04",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-7.3%",
                  week_date: "2024-03-11",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "3.4%",
                  week_date: "2024-03-18",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "2.7%",
                  week_date: "2024-03-25",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "8.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.5%",
                  week_date: "2024-04-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.6%",
                  week_date: "2024-04-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-0.5%",
                  week_date: "2024-04-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "4.7%",
                  week_date: "2024-04-22",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "2.1%",
                  week_date: "2024-04-29",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "8.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-5.2%",
                  week_date: "2024-05-06",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "11.5%",
                  week_date: "2024-05-13",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "5.0%",
                  week_date: "2024-05-20",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.1%",
                  week_date: "2024-05-27",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "7.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-2.2%",
                  week_date: "2024-06-03",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "8.7%",
                  week_date: "2024-06-10",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.6%",
                  week_date: "2024-06-17",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.5%",
                  week_date: "2024-06-24",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUL",
              mtd_data: "-3.6%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.4%",
                  week_date: "2024-07-01",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.2%",
                  week_date: "2024-07-08",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-7.2%",
                  week_date: "2024-07-15",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.5%",
                  week_date: "2024-07-22",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "-0.3%",
                  week_date: "2024-07-29",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "AUG",
              mtd_data: "8.1%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.5%",
                  week_date: "2024-08-05",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.1%",
                  week_date: "2024-08-12",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "2.1%",
                  week_date: "2024-08-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.2%",
                  week_date: "2024-08-26",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "SEP",
              mtd_data: "-4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "-3.0%",
                  week_date: "2024-09-02",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "2.8%",
                  week_date: "2024-09-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.9%",
                  week_date: "2024-09-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.1%",
                  week_date: "2024-09-23",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "-5.4%",
                  week_date: "2024-09-30",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "OCT",
              mtd_data: "-6.8%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "5.4%",
                  week_date: "2024-10-07",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-2.8%",
                  week_date: "2024-10-14",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "-6.7%",
                  week_date: "2024-10-21",
                  regime: "011",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.5%",
                  week_date: "2024-10-28",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "NOV",
              mtd_data: "4.9%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.2%",
                  week_date: "2024-11-04",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "-2.3%",
                  week_date: "2024-11-11",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "4.1%",
                  week_date: "2024-11-18",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.9%",
                  week_date: "2024-11-25",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "DEC",
              mtd_data: "7.7%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "2.8%",
                  week_date: "2024-12-30",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W2",
                  week_data: "4.9%",
                  week_date: "2024-12-02",
                  regime: "001",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W3",
                  week_data: "2.9%",
                  week_date: "2024-12-09",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "-2.9%",
                  week_date: "2024-12-16",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "-0.0%",
                  week_date: "2024-12-23",
                  regime: "001",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
        {
          year: 2025,
          ytd_data: "2.14%",
          mtds: [
            {
              month: "JAN",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2025-01-06",
                  regime: "101",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2025-01-13",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2025-01-20",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2025-01-27",
                  regime: "000",
                },
              ],
            },
            {
              month: "FEB",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2025-02-03",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2025-02-10",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2025-02-17",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2025-02-24",
                  regime: "000",
                },
              ],
            },
            {
              month: "MAR",
              mtd_data: "-2.3%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2025-03-03",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2025-03-10",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2025-03-17",
                  regime: "000",
                },
                {
                  weekNum: "W4",
                  week_data: "-0.1%",
                  week_date: "2025-03-24",
                  regime: "100",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W5",
                  week_data: "-2.2%",
                  week_date: "2025-03-31",
                  regime: "100",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "APR",
              mtd_data: "0.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2025-04-07",
                  regime: "000",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2025-04-14",
                  regime: "000",
                },
                {
                  weekNum: "W3",
                  week_data: "0.00%",
                  week_date: "2025-04-21",
                  regime: "110",
                },
                {
                  weekNum: "W4",
                  week_data: "0.00%",
                  week_date: "2025-04-28",
                  regime: "110",
                },
              ],
            },
            {
              month: "MAY",
              mtd_data: "3.0%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "0.00%",
                  week_date: "2025-05-05",
                  regime: "110",
                },
                {
                  weekNum: "W2",
                  week_data: "0.00%",
                  week_date: "2025-05-12",
                  regime: "110",
                },
                {
                  weekNum: "W3",
                  week_data: "1.1%",
                  week_date: "2025-05-19",
                  regime: "111",
                  bgColor: "#008000",
                },
                {
                  weekNum: "W4",
                  week_data: "1.9%",
                  week_date: "2025-05-26",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
            {
              month: "JUN",
              mtd_data: "1.5%",
              wtds: [
                {
                  weekNum: "W1",
                  week_data: "1.5%",
                  week_date: "2025-06-02",
                  regime: "111",
                  bgColor: "#008000",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
